/* eslint-disable indent */
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Cliente } from 'src/app/models/cliente';
import { FormaDePagamento } from 'src/app/models/forma-de-pagamento';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FormaDePagamentoService } from 'src/app/services/forma-de-pagamento.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { ClientesModalComponent } from '../clientes-modal/clientes-modal.component';
import { GlobalService } from 'src/app/services/global.service';
import { ClienteService } from 'src/app/services/cliente.service';
import { Ibge } from 'src/app/models/ibge';
import { ViaCepService } from './../../services/via-cep.service';
import { ViaCep } from 'src/app/models/viacep';
import { IbgeService } from './../../services/ibge.service';
import { UtilitarioService } from './../../services/utilitario.service';
import { MASKS } from 'ng-brazil';
import { FreteService } from 'src/app/services/frete.service';
import { Frete } from 'src/app/models/frete';
import { PremissasService } from 'src/app/services/premissas.service';
import swal from 'sweetalert2';
import { VendaEntrega } from 'src/app/models/venda-entrega';
import { VendaEnderecoModalComponent } from '../venda-endereco-modal/venda-endereco-modal.component';
import { PedidoService } from 'src/app/services/pedido.service';
import { VendaDiretaModalComponent } from '../venda-direta-modal/venda-direta-modal.component';
import { InserirValorModalComponent } from '../inserir-valor-modal/inserir-valor-modal.component';
import { AnexoModalComponent } from '../anexo-modal/anexo-modal.component';
import { SelecionarVoucherModalComponent } from '../selecionar-voucher-modal/selecionar-voucher-modal.component';
import { Voucher } from 'src/app/models/voucher';
import { TipoCalculoPedido, TipoEnderecoEntrega, TipoVendaFormaPag, TipoVoucher } from 'src/app/models/enum';
import { DescargaService } from 'src/app/services/descarga.service';
import { Descarga } from 'src/app/models/descarga';
import { VendaPergunta } from 'src/app/models/venda-pergunta';
import { QuestionarioService } from 'src/app/services/questionario.service';
import { VendaResposta } from 'src/app/models/venda-resposta';
import { ServicoEntregaService } from 'src/app/services/servico-entrega.service';
import { ServicoEntrega } from 'src/app/models/servico-entrega';
import { Seguro } from 'src/app/models/seguro';
import { SeguroService } from 'src/app/services/seguro.service';
import { VendaSeguro } from 'src/app/models/venda-seguro';
import { AlterarValorSeguroModalComponent } from '../alterar-valor-seguro-modal/alterar-valor-seguro-modal.component';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { VendaFormaPag } from 'src/app/models/venda-forma-pag';
import { MultiFormaPagamentoModalComponent } from '../multi-forma-pagamento-modal/multi-forma-pagamento-modal.component';
import { UsuarioLogado } from 'src/app/models/usuario-logado';
import { PremissasOrcPed } from 'src/app/models/premissas-orc-ped';
import { DadosCalculo } from 'src/app/models/dados-calculo';
import { PremissasSistema } from 'src/app/models/premissas-sistema';
import { ItemDesc, ItemPedido } from 'src/app/models/pedido';
import { PrecificacaoUF } from 'src/app/models/precificacao-uf';
import { PrecificacaoUFService } from 'src/app/services/precificacao-uf.service';
import { ProdutoService } from 'src/app/services/produto.service';
import { FaixaDescargaCIF } from 'src/app/models/faixa-descarga-cif';
import { FaixaDescargaCifService } from 'src/app/services/faixa-descarga-cif.service';
import { FornecedorService } from 'src/app/services/fornecedor.service';
import { Fornecedor } from 'src/app/models/fornecedor';
import { QuillCounterModule } from 'src/app/quill-editor/quill-counter-module';
import Quill from 'quill';
import { PremissasUsuario } from '../../models/premissas-usuario';
import { VoucherService } from 'src/app/services/voucher.service';
import { MultiFormaPagamentoComponent } from 'src/app/multi-forma-pagamento/multi-forma-pagamento.component';
import { VendaItemImposto } from 'src/app/models/venda-item-imposto';
import { VendaDiretaComponent } from 'src/app/venda-direta/venda-direta/venda-direta.component';
import { VendaEntregaComponent } from 'src/app/venda-entrega/venda-entrega/venda-entrega.component';
import { IndicadorAnaliseDescontoService } from 'src/app/services/indicador-analise-desconto.service';

// jquery
declare const $: any;

Quill.register('modules/counter', QuillCounterModule);

@Component({
  selector: 'app-digita-campo-modal',
  templateUrl: './digita-campo-modal.component.html',
  styleUrls: ['./digita-campo-modal.component.scss']
})
export class DigitaCampoModalComponent implements OnInit, AfterViewInit, OnDestroy {
  itens: ItemPedido[] = [];

  descAcresPrecificacaoUF: PrecificacaoUF;
  precificacoesUF: PrecificacaoUF[] = [];

  premissas: PremissasOrcPed = new PremissasOrcPed();
  premissasSistema = new PremissasSistema();
  premissasUsuario: PremissasUsuario;

  podeAtualizarValores = false;

  podeMostrarTotal = false;

  checandoDesconto = false;

  origem = 0;

  cidadeOriginal;

  cdSelecionado: Fornecedor;

  mostrarTotaisFixos = false;

  naoValidarPedido = false;
  criandoPedidoSemValidacao = false;

  valorServicoEntregaEditado = false;
  gerandoPeloOrcamento = false;
  limDesc = undefined;
  tipo: number;
  nome: any;
  cliente: Cliente;
  clienteIntegrador: Cliente;
  selecionarIntegrador = false;
  formasDePagamento: FormaDePagamento[] = [];
  formaDePagamentoRepasse: boolean = false;
  informarNome = false;
  vendaDireta = false;
  clienteFaturamento: Cliente;
  tiposDePessoa = [
    { id: 1, nome: 'FÍSICA' },
    { id: 0, nome: 'JURÍDICA' }
  ];
  tiposDeCliente = [
    { id: false, nome: 'Integrador' },
    { id: true, nome: 'Cliente Final' }
  ];
  tiposDeEnderecoEntrega = [
    { id: TipoEnderecoEntrega.Integrador, nome: 'Integrador' },
    { id: TipoEnderecoEntrega.VendaDireta, nome: 'Cliente Final' },
    { id: TipoEnderecoEntrega.Personalizado, nome: 'Personalizado' }
  ];
  tiposDeDesconto = [
    { id: 0, nome: 'Desconto' },
    { id: 1, nome: 'Acréscimo' }
  ];
  tiposDeValor = [
    { id: 0, nome: 'Percentual' },
    { id: 1, nome: 'Valor' }
  ];
  estados = [
    'AC',
    'AL',
    'AP',
    'AM',
    'BA',
    'CE',
    'DF',
    'ES',
    'GO',
    'MA',
    'MT',
    'MS',
    'MG',
    'PA',
    'PB',
    'PR',
    'PE',
    'PI',
    'RJ',
    'RN',
    'RS',
    'RO',
    'RR',
    'SC',
    'SP',
    'SE',
    'TO'
  ];
  estadoSelecionado = undefined;
  cidades: Ibge[] = [];
  cidadeSelcionado = undefined;

  ibgeEntrega: Ibge;

  public MASKS = MASKS;
  public readonly TipoEnderecoEntrega = TipoEnderecoEntrega;

  da = 0;

  tipoIntegracao;

  descontoFrete = 0;
  integradorPodeConfirmar = false;

  usandoMultiFormasPagamento = false;

  camposInvalidosEnderecoEntrega = '';
  camposInvalidosEnderecoEntregaNovo = '';

  naoCalcularFrete = false;
  naoCalcularDesconto = false;

  customPatterns = {
    V: { pattern: new RegExp('(,|[0-9]|-|\\.)') },
    0: { pattern: new RegExp('[0-9]') }
  };

  tipoFreteAnterior;

  valorTotalMultiFormaPagamento = 0;

  valorDa = 0;
  percentual = 0;
  tipoFrete: any;
  tipoCIF: any;
  frete: Frete;
  fretes: Frete[] = [];
  fretesOriginais: Frete[] = [];
  valorFrete = 0;
  localizacao: any = null;
  selecionouLocalizacao = false;
  valorTotal: any;
  valorProdutos: any;
  ibge: string;
  cupomDesconto = null;

  valorTotalFixo;
  alterou = false;

  freteDigitado = true;

  idTransportadora;

  concordarTermos = false;

  integrador = false;
  descontoMaximo = 0;
  descPadrao = 0;
  idCliente: number;
  taxaCondicao = 0;
  valorTaxaCond = 0;
  valorServico = 0;
  valorLiquido = 0;
  public config: PerfectScrollbarConfigInterface = {};
  enderecoEntrega: VendaEntrega;
  enderecoEntregaNovo: VendaEntrega;
  enderecoEntregaCompleto: string;
  idCupom;
  calculadora: boolean;
  nomeResponsavel: string;
  telefoneResponsavel: string;
  idDescarga = null;
  descargas: Descarga[] = [];
  faixasDescarga: FaixaDescargaCIF[] = [];
  faixa: FaixaDescargaCIF = new FaixaDescargaCIF();
  desabilitaDescargaCIF: boolean = false;

  formasPagamento: VendaFormaPag[] = [];

  descontoIndividual = false;

  voucher;
  dadosVoucher: Voucher;
  valorVoucher;

  tipoEnderecoSelecionado = 0; // 0- Não informado; 1 - Integrador, 2 - Venda Direta, 3- Personalizado

  freteManual = false;

  idCD: number;
  vendedor = undefined;

  mostrarMsgFreteIntegrador = false;
  msgFreteIntegrador = '';

  freteManualInicial = false;
  private exibindoMensagemSomenteFob = false;
  idClienteFaturamento;

  perguntasOriginais: VendaPergunta[] = [];
  perguntas: VendaPergunta[] = [];

  comboSimOuNao = [
    { id: 'N', descricao: 'Não' },
    { id: 'S', descricao: 'Sim' }
  ];

  respostas: VendaResposta[] = [];

  questionarioAberto = false;

  seguros: Seguro[] = [];
  segurosOriginais: Seguro[] = [];

  servicosEntrega: ServicoEntrega[] = [];
  servicoEntrega = false;
  valorServicoEntrega = 0;

  valorSeguro = 0;
  segurosSelecionados: VendaSeguro[] = [];
  segurosObrigatorios: VendaSeguro[] = [];
  segurosManuais: VendaSeguro[] = [];
  segurosObrigatoriosRemovidos: VendaSeguro[] = [];

  potencia;

  permissoesPedidoFuncionario = {
    podeEditarFrete: false,
    podeEditarServicoEntrega: false,
    podeEditarSeguro: false,
    podeDescontoIndividual: false,
    podeVerTotaisMonitores: false
  };

  valorProjeto = 0;
  valorProjetoLiquido = 0;

  avulso = false;

  bloquearTipoFreteVendaDireta = false;
  percentualFreteAvulso;

  usuarioLogado: UsuarioLogado;
  msgEnderecoAdicional = '';
  mostraMsgEnderecoAdicional: boolean = false;
  idFornecedor = null;

  qtModulos = 0;

  idFrete = null;

  verModalidades: boolean = false;
  contadorInicializacao: number = 0;

  verTextoTipoCIF: string;
  desabilitaTipoCIF: boolean = false;

  selecionarSegurosPreSelecionaveis = false;
  countInit: number = 0;

  podeAlterarCD = false;

  ipi = 0;
  ibs = 0;
  cbs = 0;

  podeAplicarVoucher = false;

  usandoArredondamento = false;
  valorParaFormasPagamento = 0;

  impostos: VendaItemImposto[] = [];
  valorImpostos = 0;
  impostosPendente = false;

  buscouClienteFaturamento = false;
  dadosVendaDireta = { clienteFaturamento: undefined };
  editandoEnderecoEntrega = false;

  alterouValorProdutos = false;

  aliqImpRef = 0;
  mostrarValoresServico = false;

  private observer?: IntersectionObserver;

  @ViewChild('multiFormaPagamentoComp', { static: false }) multiFormaPagamentoComp: MultiFormaPagamentoComponent;
  @ViewChild('vendaDiretaComp', { static: false }) vendaDiretaComp: VendaDiretaComponent;
  @ViewChild('vendaEntregaComp', { static: false }) vendaEntregaComp: VendaEntregaComponent;
  @ViewChild('totais', { static: false }) totais!: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<DigitaCampoModalComponent>,
    private router: Router,
    private carregandoService: CarregandoService,
    private formadePagamentoService: FormaDePagamentoService,
    private notificacaoService: NotificacaoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private globalService: GlobalService,
    private clienteService: ClienteService,
    private viaCepService: ViaCepService,
    private ibgeService: IbgeService,
    private utilitarioService: UtilitarioService,
    private freteService: FreteService,
    private premissasService: PremissasService,
    private pedidoService: PedidoService,
    private descargaService: DescargaService,
    private questionarioService: QuestionarioService,
    private servicoEntregaService: ServicoEntregaService,
    private seguroService: SeguroService,
    private funcionarioService: FuncionarioService,
    private precificacaoUFService: PrecificacaoUFService,
    private produtoService: ProdutoService,
    private faixaDescargaService: FaixaDescargaCifService,
    private fornecedorService: FornecedorService,
    private voucherService: VoucherService,
    private changeDetectorRef: ChangeDetectorRef,
    private indicadorService: IndicadorAnaliseDescontoService
  ) {}

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver(([entry]) => {
      this.mostrarTotaisFixos = !entry.isIntersecting;
    });

    this.observer.observe(this.totais.nativeElement);
  }

  async ngOnInit(): Promise<void> {
    this.usuarioLogado = await this.globalService.consultaUsuario();
    this.integrador = await this.globalService.integrador();

    if (!this.integrador) {
      await this.buscarPodeAlterarCD();
    }

    await this.buscarPremissasOrcPed();

    await this.buscarPremissasSistema();
    await this.buscarPremissasUsuario();

    if (this.premissasSistema.usarPrecificacaoPorUF) {
      await this.buscarPrecificacoesUF();
    }

    if (this.vendaDireta) {
      this.definirDadosVendaDireta();
    }

    if (!this.premissasSistema.habilitarConfTermoAceiteFinalizarPedido) {
      this.concordarTermos = true;
    }

    if (!this.integrador) {
      this.premissas.mostrarValores = true;
    }

    if (this.premissas.camposQuestionariosObrigatorio) {
      this.questionarioAberto = true;
    }

    await this.buscarFormasDePagamento();

    await this.inicializacao();

    this.definirDadosVendaDireta();

    this.buscarTiposDeEnderecoEntrega();

    await this.buscarDescontoMaximo();

    if (this.avulso && this.premissas.pFreteManualAvulso) {
      this.freteManual = true;
    }

    if (this.premissas.usarSeguro) {
      await this.buscarSeguros();
    }

    if (this.premissas.usarServicoEntrega) {
      this.buscarServicosEntrega();
    }

    this.definirCamposInvalidosEnderecoEntrega();

    if (this.integrador || (this.idCliente !== null && this.idCliente !== undefined)) {
      await this.buscarIntegrador();
    }

    await this.atualizaMultiFormasPagamento();

    if (this.tipoFrete === undefined && this.tipoFrete === null) {
      this.tipoFrete = 0;
    }

    await this.buscarPerguntasEntrega();

    await this.buscarDescargas();

    if (!this.integrador) {
      await this.buscarPermissoesFuncionario();
    }

    this.integradorPodeConfirmar = this.usuarioLogado.podeConfirmarPedido;

    if ((this.tipo === 0 || this.criandoPedidoSemValidacao) && !this.vendaDireta) {
      if (this.integrador && !this.calculadora) {
        await this.buscarUFCidadeIntegrador();
      }
      if (this.calculadora) {
        await this.buscarCidadesPorEstado();
      }
    }

    await this.buscarEnderecoDeEntrega();

    if (!this.premissas.usarTbFrete) {
      this.naoCalcularFrete = true;
    }

    if (!this.bloquearTipoFreteVendaDireta && !this.descontoIndividual) {
      await this.buscarDescAcresInicial();
    }

    await this.atualizaDesconto(
      this.idCupom !== null &&
        this.idCupom !== undefined &&
        this.idCupom &&
        (!this.podeAtualizarValores || this.descontoIndividual)
        ? 1
        : 0,
      this.valorTotalFixo !== null && this.valorTotalFixo !== undefined && this.valorTotalFixo > 0
    );

    this.podeAtualizarValores = true;

    if (this.premissasSistema.habilitarApiImposto && this.origem === 3 && this.impostosPendente) {
      this.alterou = true;
    }

    await this.atualizaValores();
    await this.buscarMsgEnderecoAdicional();

    this.podeMostrarTotal = true;
  }

  async buscarPodeAlterarCD() {
    try {
      this.carregandoService.mostra('buscarPodeAlterarCD');
      this.podeAlterarCD = await this.funcionarioService.consultaPodeAlterarCD().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPodeAlterarCD');
    }
  }

  async buscarPodeAplicarVoucher() {
    if (this.premissas.ativarVoucher && this.cliente !== undefined && this.cliente !== null) {
      this.podeAplicarVoucher = await this.voucherService.podeAplicarVouchers(this.cliente.id).toPromise();
    }
  }

  async buscarCD() {
    try {
      this.carregandoService.mostra('buscarCD');
      this.cdSelecionado = await this.fornecedorService.consultarPorIdFornecedor(this.idCD).toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarCD');
    }
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
      this.desabilitaDescargaCIF = !this.premissasSistema.usaDescargaCif;
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasSistema');
    }
  }

  async excluirCupomDesconto(naoValidar?) {
    if (this.cupomDesconto === null) return;

    if (!naoValidar && this.premissasSistema.manterCupomDesconto) return;

    this.cupomDesconto = null;

    this.alterou = true;

    await this.buscarDescontoMaximo();
    await this.atualizaDesconto(0);
  }

  async buscarDescontoMaximo() {
    try {
      this.carregandoService.mostra('buscarDescontoMaximo');

      this.descontoMaximo = await this.pedidoService
        .calcularDescontoMaximo(
          this.integrador
            ? this.usuarioLogado.id
            : this.cliente === null || this.cliente === undefined
              ? this.idCliente
              : this.cliente.id,
          this.vendedor === null || this.vendedor === undefined ? null : this.vendedor.idFuncion,
          this.da,
          this.cupomDesconto
        )
        .toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarDescontoMaximo');
    }
  }

  async buscarDescAcresInicial() {
    if (this.gerandoPeloOrcamento) {
      return;
    }

    try {
      this.carregandoService.mostra('buscarDescAcresInicial');

      this.percentual = await this.pedidoService
        .calcularDescAcresInicial(
          this.integrador
            ? this.usuarioLogado.id
            : this.cliente === null || this.cliente === undefined
              ? this.idCliente
              : this.cliente.id,
          this.vendedor === null || this.vendedor === undefined ? null : this.vendedor.idFuncion,
          this.da
        )
        .toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarDescAcresInicial');
    }
  }

  async buscarCidadesPorEstado(buscarFreteAutomatico: boolean = true) {
    try {
      this.carregandoService.mostra('buscarCidade');
      this.cidades = await this.ibgeService.consultarPorEstado(this.estadoSelecionado).toPromise();
      this.cidadeSelcionado = this.cidades.find((s) => s.cod === this.cidadeSelcionado)
        ? this.cidades.find((s) => s.cod === this.cidadeSelcionado).cod
        : '';

      if (buscarFreteAutomatico) {
        await this.buscarFreteAutomatico();
      }
    } catch (erro) {
    } finally {
      this.carregandoService.esconde('buscarCidade');
    }
  }

  async inicializacao() {
    this.origem = this.data.origem;
    this.avulso = this.data.avulso;
    this.idClienteFaturamento = this.data.idClienteFaturamento;
    this.potencia = this.data.potencia;
    this.vendaDireta = this.data.vendaDireta ? this.data.vendaDireta : undefined;
    this.freteManualInicial = this.data.freteManual;
    this.freteManual = this.data.freteManual;
    this.valorFrete = this.data.valorFrete;
    this.tipo = this.data.tipo;

    this.premissas.confirmarSemValidar = this.premissas.confirmarSemValidar && this.tipo === 1;

    this.naoValidarPedido =
      this.premissasSistema.naoValidarPedido &&
      this.premissasSistema.origensParaNaoValidarPedido.some((p) => p === this.origem);

    this.selecionarIntegrador = this.data.selecionarIntegrador;
    this.informarNome = this.data.informarNome;
    this.valorProdutos = Number(Number(this.data.valorProdutos).toFixed(2));
    this.valorTotal = this.valorProdutos ? this.valorProdutos : 0;
    this.ibge = this.data.ibge ? this.data.ibge : '';
    this.tipoFrete = this.data.tipoFrete !== undefined ? this.data.tipoFrete : this.tipoFrete;
    this.tipoCIF =
      this.data.tipoCIF !== undefined ? this.data.tipoCIF : this.premissasSistema.usaDescargaCif ? null : 0;
    this.valorTotalFixo = this.data.valorTotalFixo;

    this.ipi = this.data.ipi !== undefined && this.data.ipi !== null ? this.data.ipi : this.ipi;
    this.ibs = this.data.ibs !== undefined && this.data.ibs !== null ? this.data.ibs : this.ibs;
    this.cbs = this.data.cbs !== undefined && this.data.cbs !== null ? this.data.cbs : this.cbs;

    this.tipoFreteAnterior =
      this.data.tipoFreteAnterior !== undefined ? this.data.tipoFreteAnterior : this.tipoFreteAnterior;
    this.bloquearTipoFreteVendaDireta =
      this.data.bloquearTipoFreteVendaDireta !== undefined
        ? this.data.bloquearTipoFreteVendaDireta
        : this.bloquearTipoFreteVendaDireta;

    if (this.data.tipoLocalizacao != null) {
      this.localizacao = this.data.tipoLocalizacao;
      this.selecionouLocalizacao = true;
    } else {
      this.localizacao = !this.premissasSistema.habilitaValidacaoLocalizacao ? 1 : this.localizacao;
    }

    this.valorDa = this.data.valorDa !== undefined ? this.data.valorDa : this.valorDa;
    this.da = this.data.da !== undefined ? this.data.da : this.da;
    this.percentual = this.data.percentual !== undefined ? this.data.percentual : this.percentual;
    this.idCliente = this.data.idCliente !== undefined ? this.data.idCliente : this.idCliente;
    this.valorTaxaCond = this.data.taxaDA !== undefined ? this.data.taxaDA : this.valorTaxaCond;

    this.idCupom = this.data.idCupom;

    this.alterou = this.idCupom === null || this.idCupom === undefined;

    this.criandoPedidoSemValidacao = this.naoValidarPedido && (this.idCupom === null || this.idCupom === undefined);

    this.premissas.confirmarSemValidar =
      (this.premissas.confirmarSemValidar && this.tipo === 1) ||
      (this.naoValidarPedido && !this.criandoPedidoSemValidacao);

    this.selecionarSegurosPreSelecionaveis = !this.avulso && (this.idCupom === null || this.idCupom === undefined);

    this.estadoSelecionado = this.data.uf !== undefined ? this.data.uf : undefined;
    this.cidadeSelcionado = this.data.cidade !== undefined ? this.data.cidade : undefined;
    this.cidadeOriginal = this.data.cidade !== undefined ? this.data.cidade : undefined;
    this.calculadora = this.data.calculadora;
    this.nomeResponsavel = this.data.nomeResponsavel;
    this.telefoneResponsavel = this.data.telefoneResponsavel;
    this.idDescarga = this.data.idDescarga !== null && this.data.idDescarga !== undefined ? this.data.idDescarga : null;

    this.itens = this.data.itens;
    this.descAcresPrecificacaoUF = this.data.descAcresPrecificacaoUF;

    this.voucher = this.data.voucher;
    this.dadosVoucher = this.data.dadosVoucher;

    this.cupomDesconto = this.data.cupomDesconto !== undefined ? this.data.cupomDesconto : this.cupomDesconto;

    this.valorServico =
      this.data.valorServico !== undefined ? Number(this.data.valorServico) : Number(this.valorServico);
    this.valorLiquido = this.data.valorLiquido !== undefined ? this.data.valorLiquido : this.valorLiquido;

    this.naoCalcularFrete = this.data.naoCalcularFrete;
    this.naoCalcularDesconto = this.data.naoCalcularDesconto;

    this.nome = this.data.nome;
    this.descontoFrete = this.data.descontoFrete;
    this.cliente = this.data.cliente;

    await this.buscarPodeAplicarVoucher();

    this.clienteIntegrador = this.data.clienteIntegrador;

    this.limDesc = this.data.limDesc;

    this.descontoIndividual =
      this.data.descontoIndividual !== undefined ? this.data.descontoIndividual : this.descontoIndividual;

    this.vendedor = this.data.vendedor;

    this.idCD = this.data.idCD;

    if (this.premissas.pCentroDistribuicao && this.premissasSistema.habilitarCDPorCidade && this.idCD) {
      await this.buscarCD();
    }

    this.percentualFreteAvulso = this.data.percentualFreteAvulso;

    this.tipoIntegracao = this.data.tipoIntegracao;

    this.gerandoPeloOrcamento = this.data.gerandoPeloOrcamento ? true : false;

    this.servicoEntrega = this.data.servicoEntrega !== undefined ? this.data.servicoEntrega : false;
    this.valorServicoEntrega = this.data.valorServicoEntrega;
    this.valorServicoEntregaEditado = this.data.servicoEntregaManual;
    this.formasPagamento =
      this.data.formasPagamento !== undefined && this.data.formasPagamento !== null
        ? this.data.formasPagamento
        : this.formasPagamento;

    if (this.formasPagamento === null || this.formasPagamento === undefined || this.formasPagamento.length === 0) {
      this.formasPagamento = [];
      const novaForma = new VendaFormaPag();
      novaForma.tipo = TipoVendaFormaPag.Variavel;
      novaForma.valor = 0;
      novaForma.total = 0;
      this.formasPagamento.push(novaForma);
    } else if (
      this.formasPagamento.length === 1 &&
      !this.data.usandoMultiFormasPagamento &&
      this.premissas.podeUsarMultiFormaPagamento &&
      this.formasPagamento[0].tipo !== TipoVendaFormaPag.Variavel
    ) {
      this.formasPagamento[0].tipo = TipoVendaFormaPag.Variavel;
      this.formasPagamento[0].total = Number(
        this.valorTotalFixo === null || this.valorTotalFixo === undefined ? this.valorTotal : this.valorTotalFixo
      );
    }

    // this.verificaFormaPagamentoRepasse();

    this.usandoMultiFormasPagamento = this.premissas.podeUsarMultiFormaPagamento;

    this.impostos =
      this.data.impostos !== undefined && this.data.impostos !== null ? this.data.impostos : this.impostos;

    this.valorImpostos =
      this.data.valorImpostos !== undefined && this.data.valorImpostos !== null
        ? this.data.valorImpostos
        : this.valorImpostos;

    this.impostosPendente =
      this.data.impostosPendente !== undefined && this.data.impostosPendente !== null
        ? this.data.impostosPendente
        : this.impostosPendente;

    this.idFornecedor = this.data.idFornecedor;

    this.qtModulos = this.data.qtModulos;

    if (this.data.valorProjeto) {
      this.valorProjeto = this.data.valorProjeto;
      this.valorProjetoLiquido = this.data.valorProjetoLiquido;
    }

    if (this.data.seguros) {
      let seguros = [...this.data.seguros];

      this.segurosSelecionados = [...seguros.filter((p) => !p.obrigatorioRemovido)];
      this.segurosObrigatoriosRemovidos = [...seguros.filter((p) => p.obrigatorioRemovido)];
    }

    this.idFrete = this.data.idFrete !== undefined ? this.data.idFrete : null;

    if (this.cliente && this.clienteIntegrador && !this.informarNome) {
      if (!this.calculadora) {
        if (
          (this.tipo === 0 || this.criandoPedidoSemValidacao) &&
          !this.vendaDireta &&
          !this.bloquearTipoFreteVendaDireta &&
          !this.premissasSistema.habilitarCDPorCidade
        ) {
          this.estadoSelecionado = this.clienteIntegrador.uf;
          await this.buscarCidadeIntegrador();
        } else {
          await this.completarEnderecoEntrega(false, this.alterou);
        }
      }
    }

    if (this.data.cliente) {
      await this.atualizarDadosCliente(this.data.cliente);
    }

    if (this.vendaDireta) {
      if (this.idClienteFaturamento) {
        await this.buscarClienteFaturamento();
      } else {
        this.clienteFaturamento = this.data.clienteFaturamento;
        await this.atualizaDadosClienteFaturamento();
        this.buscarTiposDeEnderecoEntrega();
        this.definirDadosVendaDireta();
      }
    }

    if (this.premissasSistema.usaDescargaCif) {
      this.buscarFaixasDescarga();
    } else {
      this.tipoCIF = 0;
    }

    this.aliqImpRef = this.premissasUsuario.aliquotaDeImpostoReferencial;
  }

  buscarFaixasDescarga() {
    this.carregandoService.mostra('buscarFaixaDescargaCif');
    this.faixaDescargaService.consultarFaixas().subscribe(
      async (dados) => {
        this.faixasDescarga = dados;

        if (this.faixasDescarga != null && this.faixasDescarga.length > 0) {
          if (this.itens != null && this.itens.length > 0) {
            this.itens.forEach((it) => {
              if (it.produtoTela.familia === 2) {
                this.faixa = this.faixasDescarga.find((f) => it.qt >= f.de && it.qt <= f.ate);

                this.desabilitaDescargaCIF = this.faixa == null || this.faixa === undefined;
              } else if (it.produtoTela.familia === 7) {
                it.produtoTela.composicao.forEach((c) => {
                  if (c.produtoMP.familia === 2) {
                    this.faixa = this.faixasDescarga.find((f) => c.qt * it.qt >= f.de && c.qt * it.qt <= f.ate);

                    this.desabilitaDescargaCIF = this.faixa == null || this.faixa === undefined;
                  }
                });
              }
            });
          } else {
            this.faixa = this.faixasDescarga.find((f) => this.qtModulos >= f.de && this.qtModulos <= f.ate);

            this.desabilitaDescargaCIF = this.faixa == null || this.faixa === undefined;
          }
        } else {
          this.desabilitaDescargaCIF = true;
        }

        this.carregandoService.esconde('buscarFaixaDescargaCif');

        this.avaliarMensagemDescarga();
      },
      (err) => {
        this.carregandoService.esconde('buscarFaixaDescargaCif');
        this.notificacaoService.erro(err);
      }
    );
  }

  avaliarMensagemDescarga() {
    this.verTextoTipoCIF = null;

    if (!this.premissasSistema.usaDescargaCif) return;

    if (this.tipoFrete === 1) return;

    if (!this.faixa) {
      this.desabilitaTipoCIF = true;
      this.tipoCIF = 0;
      this.verTextoTipoCIF = 'Responsabilidade de descarga total do integrador.';

      return;
    }

    const ate = this.faixa.ate;

    if (ate > 144) {
      this.desabilitaTipoCIF = true;
      this.tipoCIF = 0;
      this.verTextoTipoCIF = 'Responsabilidade de descarga total do integrador.';
      return;
    }

    this.desabilitaTipoCIF = false;
    if (this.tipoCIF == null) return;

    switch (ate) {
      case 36:
        this.verTextoTipoCIF =
          this.tipoCIF === 0
            ? 'Responsabilidade de descarga total do integrador.'
            : 'Caso haja necessidade de empilhadeira ou transbordo o custo adicional será de responsabilidade do integrador.';
        break;

      case 72:
      case 144:
        this.verTextoTipoCIF =
          this.tipoCIF === 0
            ? 'Responsabilidade de descarga total do integrador.'
            : 'Caso haja necessidade de empilhadeira ou transbordo o custo adicional será de responsabilidade do integrador.';
        break;

      default:
        this.desabilitaTipoCIF = true;
        this.tipoCIF = 0;
        this.verTextoTipoCIF = 'Responsabilidade de descarga total do integrador.';

        break;
    }
  }

  async buscarIntegrador() {
    try {
      this.carregandoService.mostra('buscarIntegrador');
      const idCliente = this.integrador ? this.usuarioLogado.id : this.idCliente;

      this.clienteIntegrador = this.premissasUsuario.atualizaDadosReceitaIntegrador
        ? await this.clienteService.consultarAtualizadoReceita(idCliente, true).toPromise()
        : await this.clienteService.consultarPorIdCliente(idCliente, true).toPromise();

      this.descontoFrete = this.clienteIntegrador.descFrete;
    } catch (erro) {
    } finally {
      this.carregandoService.esconde('buscarIntegrador');
    }
  }

  async buscarPremissasOrcPed() {
    try {
      this.carregandoService.mostra('buscarPremissasOrcPed');
      this.premissas = await this.premissasService.consultarPremissasOrcPed().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasOrcPed');
    }
  }

  async buscarDescargas() {
    try {
      this.carregandoService.mostra('buscarDescargas');
      this.descargas = await this.descargaService.consultarDescargas().toPromise();
      this.descargas.unshift({ id: null, descricao: 'Sem descarga', percentual: 0 });
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarDescargas');
    }
  }

  async alterarTipoEndereco() {
    switch (this.tipoEnderecoSelecionado) {
      case TipoEnderecoEntrega.Integrador:
        await this.copiaEnderecoIntegrador();
        break;
      case TipoEnderecoEntrega.VendaDireta:
        await this.copiaEnderecoVendaDireta();
        break;
      case TipoEnderecoEntrega.Personalizado:
        await this.copiaEnderecoNovo();
        break;
      default:
        this.gerarEnderecoEntregaCompleto();
        break;
    }

    if (this.premissasSistema.limparCupomDescontoAoAlterarCidadeEntrega) {
      await this.excluirCupomDesconto();
    }
  }

  aplicarVoucher() {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(SelecionarVoucherModalComponent, {
      width: largura > 550 ? '590px' : $('body').width().toString() + 'px',
      data: {
        idCliente: this.clienteIntegrador.id,
        valorTotalPedido: this.valorProdutos
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(async (result: Voucher) => {
      if (result) {
        this.voucher = result.id;

        this.dadosVoucher = result;
        this.alterou = true;

        if (
          this.dadosVoucher.tipoVoucher === TipoVoucher.FormaPagamento &&
          this.dadosVoucher.excluirCupomDesconto &&
          this.cupomDesconto !== null &&
          this.cupomDesconto !== undefined
        ) {
          await this.excluirCupomDesconto(true);
        } else {
          await this.atualizaValores();
        }
      }
    });
  }

  async removerVoucher() {
    this.voucher = undefined;
    this.valorVoucher = undefined;
    this.dadosVoucher = undefined;

    await this.atualizaValores();
  }

  pesquisarCliente() {
    const dialogRef = this.dialog.open(ClientesModalComponent, {
      width: $('body').width().toString() + 'px',
      data: {
        gi: 1,
        esconderBotao: true
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.atualizarDadosCliente(result.cliente);
      }
    });
  }

  async atualizarDadosCliente(cliente) {
    this.descontoFrete = cliente.descFrete;
    this.cliente = cliente;
    this.clienteIntegrador = cliente;

    this.buscarTiposDeEnderecoEntrega();

    await this.buscarPodeAplicarVoucher();

    if (this.premissasUsuario.atualizaDadosReceitaIntegrador) {
      await this.buscarClienteAtualizadoReceita(cliente.id);
    }

    if (!this.calculadora) {
      if (
        (this.tipo === 0 || this.criandoPedidoSemValidacao) &&
        !this.vendaDireta &&
        !this.bloquearTipoFreteVendaDireta &&
        !this.premissasSistema.habilitarCDPorCidade
      ) {
        this.estadoSelecionado = this.clienteIntegrador.uf;
        await this.buscarCidadeIntegrador();
      } else {
        await this.completarEnderecoEntrega(false, this.alterou);
      }
    }
  }

  async buscarClienteAtualizadoReceita(idCliente: number) {
    try {
      this.carregandoService.mostra('buscarClienteAtualizadoReceita');
      const cliente = await this.clienteService.consultarAtualizadoReceita(idCliente, true, true).toPromise();

      this.cliente.listaCnaes = cliente.listaCnaes;
      this.cliente.optanteSimples = cliente.optanteSimples;
      this.cliente.dataSituacaoSimples = cliente.dataSituacaoSimples;
      this.cliente.optanteSimei = cliente.optanteSimei;
      this.cliente.dataSituacaoSimei = cliente.dataSituacaoSimei;
      this.cliente.dataAtualizacaoReceita = cliente.dataAtualizacaoReceita;
      this.cliente.fonteAtualizacaoReceita = cliente.fonteAtualizacaoReceita;

      this.clienteIntegrador.listaCnaes = cliente.listaCnaes;
      this.clienteIntegrador.optanteSimples = cliente.optanteSimples;
      this.clienteIntegrador.dataSituacaoSimples = cliente.dataSituacaoSimples;
      this.clienteIntegrador.optanteSimei = cliente.optanteSimei;
      this.clienteIntegrador.dataSituacaoSimei = cliente.dataSituacaoSimei;
      this.clienteIntegrador.dataAtualizacaoReceita = cliente.dataAtualizacaoReceita;
      this.clienteIntegrador.fonteAtualizacaoReceita = cliente.fonteAtualizacaoReceita;
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarClienteAtualizadoReceita');
    }
  }

  validarPreenchimentoQuestionario() {
    if (this.tipo === 0 || !this.premissas.usarQuestionarioEntrega || this.criandoPedidoSemValidacao) {
      return true;
    }

    const temCamposNaoPreenchidos = this.premissas.usarQuestionarioEntrega
      ? this.perguntas.some(
          (p) =>
            ((p.tipo === 0 || p.tipo === 2) && (p.respostaSN === undefined || p.respostaSN === null)) ||
            ((p.tipo === 1 || p.tipo === 2) &&
              (p.respostaTexto === undefined ||
                p.respostaTexto === null ||
                p.respostaTexto === '' ||
                !p.respostaTexto.length))
        )
      : undefined;
    return (
      !this.premissas.camposQuestionariosObrigatorio ||
      (this.premissas.camposQuestionariosObrigatorio && !temCamposNaoPreenchidos)
    );
  }

  validarCD() {
    return (
      // this.tipoFrete === 1 ||
      this.podeAlterarCD ||
      !this.premissas.pCentroDistribuicao ||
      (this.premissas.pCentroDistribuicao && !this.premissasSistema.habilitarCDPorCidade) ||
      (this.premissas.pCentroDistribuicao &&
        this.premissasSistema.habilitarCDPorCidade &&
        this.enderecoEntrega &&
        this.enderecoEntrega.ibge !== null &&
        this.enderecoEntrega.ibge !== undefined &&
        ((this.tipo !== 0 && !this.criandoPedidoSemValidacao) ||
          (this.cidadeSelcionado !== null && this.cidadeSelcionado !== undefined)) &&
        ((this.ibgeEntrega && this.ibgeEntrega.cd === this.idCD) ||
          (this.enderecoEntrega && Number(this.enderecoEntrega.ibge) === Number(this.cidadeOriginal))))
    );
  }

  validar() {
    // this.testeValidar();

    if (this.tipo === 0 || this.criandoPedidoSemValidacao) {
      return (
        this.validarPreenchimentoQuestionario() &&
        this.tipoCIF != null &&
        this.localizacao != null &&
        this.validarCD() &&
        (this.vendaDireta === null || this.vendaDireta === undefined || this.validarVendaDireta()) &&
        this.validarTipoFrete(false) &&
        // (!this.usandoMultiFormasPagamento || (this.usandoMultiFormasPagamento && this.validarMultiFormasPagamento())) &&
        (!this.informarNome || (this.informarNome && this.nome)) &&
        (!this.selecionarIntegrador ||
          (this.selecionarIntegrador &&
            this.cliente &&
            (!this.premissas.usarTbFrete ||
              (this.premissas.usarTbFrete && this.tipoFrete !== null && this.tipoFrete !== undefined)))) &&
        (this.vendaDireta && this.tipoFrete === 0
          ? this.enderecoEntrega !== null &&
            this.enderecoEntrega !== undefined &&
            this.enderecoEntrega.tipoEndereco !== 0 &&
            this.enderecoEntrega.cep !== null &&
            this.enderecoEntrega.cep !== undefined &&
            (this.enderecoEntrega.antigo ||
              (this.enderecoEntrega.tipo !== null &&
                this.enderecoEntrega.tipo !== undefined &&
                this.enderecoEntrega.cpfCnpj !== null &&
                this.enderecoEntrega.cpfCnpj !== undefined &&
                this.enderecoEntrega.cpfCnpj !== '' &&
                (this.enderecoEntrega.tipo === 1 ||
                  !this.premissas.inscricaoEstadualObg ||
                  (this.enderecoEntrega.rgIe !== null &&
                    this.enderecoEntrega.rgIe !== undefined &&
                    this.enderecoEntrega.rgIe !== '')) &&
                this.enderecoEntrega.nome !== null &&
                this.enderecoEntrega.nome !== undefined &&
                this.enderecoEntrega.nome !== ''))
          : true)
      );
    } else {
      return (
        this.validarCD() &&
        this.validarVendaDireta() &&
        this.validarPreenchimentoQuestionario() &&
        this.validarTipoFrete(false) &&
        this.tipoCIF != null &&
        this.localizacao != null && // this.tipoFrete === 1 ||
        this.enderecoEntrega !== null &&
        this.enderecoEntrega !== undefined &&
        (this.enderecoEntrega.tipoEndereco !== TipoEnderecoEntrega.Personalizado ||
          (this.vendaEntregaComp !== null && this.vendaEntregaComp !== undefined && this.vendaEntregaComp.validar())) &&
        this.enderecoEntrega.tipoEndereco !== 0 &&
        this.enderecoEntrega.cep !== null &&
        this.enderecoEntrega.cep !== undefined &&
        (this.enderecoEntrega.antigo ||
          (this.enderecoEntrega.tipo !== null &&
            this.enderecoEntrega.tipo !== undefined &&
            this.enderecoEntrega.cpfCnpj !== null &&
            this.enderecoEntrega.cpfCnpj !== undefined &&
            this.enderecoEntrega.cpfCnpj !== '' &&
            (this.enderecoEntrega.tipo === 1 ||
              !this.premissas.inscricaoEstadualObg ||
              (this.enderecoEntrega.rgIe !== null &&
                this.enderecoEntrega.rgIe !== undefined &&
                this.enderecoEntrega.rgIe !== '')) &&
            this.enderecoEntrega.nome !== null &&
            this.enderecoEntrega.nome !== undefined &&
            this.enderecoEntrega.nome !== '')) &&
        (!this.premissasSistema.nomeTelResponsavelObgPedido ||
          (this.tipoFrete === 1 && !this.premissasSistema.mostrarEnderecoEntregaFob) ||
          (this.premissasSistema.nomeTelResponsavelObgPedido &&
            this.nomeResponsavel !== null &&
            this.nomeResponsavel !== undefined &&
            this.nomeResponsavel !== '' &&
            this.telefoneResponsavel !== null &&
            this.telefoneResponsavel !== undefined &&
            this.telefoneResponsavel !== '' &&
            this.telefoneResponsavel
              .replace('(', '')
              .replace(')', '')
              .replace('-', '')
              .replace(new RegExp('_', 'g'), '')
              .trim() !== '')) &&
        (!this.informarNome || (this.informarNome && this.nome)) &&
        ((!this.usandoMultiFormasPagamento &&
          this.formasPagamento[0].idFormaPag &&
          this.formasPagamento[0].idCondPag) ||
          (this.usandoMultiFormasPagamento && this.validarMultiFormasPagamento())) &&
        (!this.selecionarIntegrador ||
          (this.selecionarIntegrador &&
            this.cliente &&
            (!this.premissas.usarTbFrete ||
              (this.premissas.usarTbFrete && this.tipoFrete !== null && this.tipoFrete !== undefined))))
      );
    }
  }

  validarMultiFormasPagamento() {
    if (this.multiFormaPagamentoComp) {
      return this.multiFormaPagamentoComp.validar();
    } else {
      return true;
    }
  }

  fechar(confirmar?, comprovante?) {
    this.enderecoEntrega.nomeResponsavel = this.nomeResponsavel;
    this.enderecoEntrega.telefoneResponsavel = this.telefoneResponsavel;

    if (
      this.enderecoEntrega !== undefined &&
      this.enderecoEntrega !== null &&
      this.enderecoEntrega.ibge !== undefined &&
      this.enderecoEntrega.ibge !== null
    ) {
      this.enderecoEntrega.ibge = Number(this.enderecoEntrega.ibge);
    }

    this.respostas = this.perguntas.map((p) => {
      const resp = new VendaResposta();
      resp.idPergunta = p.id;

      resp.respostaSN = p.respostaSN;

      resp.respostaTexto = p.respostaTexto;
      return resp;
    });

    let retorno = {
      nome: this.nome,
      da: this.da,
      formasPagamento: this.formasPagamento,
      cliente: this.cliente,
      vendaDireta: this.vendaDireta,
      clienteFaturamento: this.vendaDireta ? this.clienteFaturamento : undefined,
      valorDa: this.valorDa,
      percentual: this.percentual,
      tipoFrete: this.tipoFrete !== undefined && this.tipoFrete !== null ? this.tipoFrete : 0,
      localizacao: this.localizacao !== undefined && this.localizacao !== null ? this.localizacao : 1,
      valorTotal: this.valorTotal,
      txLocalizacao:
        (this.localizacao !== undefined && this.localizacao !== null ? this.localizacao : 1) === 0 &&
        this.tipoFrete === 0 &&
        this.frete
          ? this.frete.taxaRural
          : 0,
      valorFrete: this.tipoFrete === 0 ? this.valorFrete : 0,
      entrega: this.frete ? this.frete.prazoTotal : 0,
      taxaDA: this.valorTaxaCond,
      enderecoEntrega: this.enderecoEntrega,
      valorServico: Number(this.valorServico),
      valorLiquido: this.valorLiquido,
      idTransportadora:
        this.premissas.usarTbFrete && this.frete !== null && this.frete !== undefined
          ? this.frete.idTransportadora
          : undefined,
      confirmar: confirmar,
      comprovante: comprovante,
      voucher: this.voucher,
      valorVoucher: this.valorVoucher,
      dadosVoucher: this.dadosVoucher,
      idDescarga: this.idDescarga,
      freteManual: this.freteManual,
      respostas: this.respostas,
      seguros: [
        ...this.segurosSelecionados,
        ...this.segurosObrigatoriosRemovidos.filter(
          (p) => !this.segurosSelecionados.some((pp) => pp.idSeguro === p.idSeguro)
        )
      ],
      servicoEntrega: this.servicoEntrega,
      valorServicoEntrega:
        this.valorServicoEntrega !== null && this.valorServicoEntrega !== undefined
          ? Number(this.valorServicoEntrega)
          : 0,
      servicoEntregaManual: this.valorServicoEntregaEditado,
      valorProjeto: this.premissas.pUsarValorProjeto ? Number(this.valorProjeto) : 0,
      valorProjetoLiquido:
        this.premissas.pUsarValorProjeto && this.valorProjetoLiquido ? Number(this.valorProjetoLiquido) : 0,
      valorTotalFixo: this.valorTotalFixo,
      valorProdutos: this.valorProdutos,
      itens: this.itens,
      descAcresPrecificacaoUF: this.descAcresPrecificacaoUF,
      enderecoEntregaCompleto: this.enderecoEntregaCompleto,
      cupomDesconto: this.cupomDesconto,
      tipoCIF:
        this.premissasSistema.usaDescargaCif && this.tipoCIF !== undefined && this.tipoCIF !== null ? this.tipoCIF : 0,
      idFrete: this.frete.id,
      ipi: this.ipi,
      ibs: this.ibs,
      cbs: this.cbs,
      usandoMultiFormasPagamento: this.usandoMultiFormasPagamento,
      impostos: this.impostos,
      valorImpostos: this.valorImpostos,
      impostosPendente: this.impostosPendente
    };

    this.dialogRef.close(retorno);
  }

  voltar() {
    this.dialogRef.close();
  }

  async buscarFormasDePagamento() {
    try {
      this.carregandoService.mostra('buscaFormasDePagamento');
      this.formasDePagamento = await this.formadePagamentoService.consultar(-1).toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscaFormasDePagamento');
    }
  }

  async buscarClienteFaturamento() {
    try {
      this.carregandoService.mostra('buscarClienteFaturamento');
      this.clienteFaturamento = await this.pedidoService.consultarClienteVendaDireta(this.idCupom).toPromise();
      await this.atualizaDadosClienteFaturamento();
      this.buscarTiposDeEnderecoEntrega();
      this.definirDadosVendaDireta();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarClienteFaturamento');
    }
  }

  async buscarPerguntasEntrega() {
    if (this.tipoFrete == null || this.tipoFrete == undefined) {
      this.tipoFrete = 0;
    }

    try {
      this.carregandoService.mostra('buscarPerguntasEntrega');
      this.perguntasOriginais = await this.questionarioService.consultarLista(this.tipoFrete).toPromise();
      this.perguntas = this.perguntasOriginais.filter((p) => p.status);
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPerguntasEntrega');
    }
  }

  async buscarPermissoesFuncionario() {
    try {
      this.carregandoService.mostra('buscarPermissoesFuncionario');
      this.permissoesPedidoFuncionario = await this.funcionarioService.consultarPermissoesPedido().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPermissoesFuncionario');
    }
  }

  async atualizaDadosClienteFaturamento() {
    this.buscouClienteFaturamento = true;

    this.estadoSelecionado =
      this.clienteFaturamento !== null && this.clienteFaturamento !== undefined
        ? this.estados.find((s) => s === this.clienteFaturamento.uf)
        : undefined;

    await this.buscarCidades();

    if (this.bloquearTipoFreteVendaDireta && this.vendaDireta) {
      this.copiaEnderecoVendaDireta();
    }
  }

  buscarEnderecoPorCep() {
    this.carregandoService.mostra('buscaEnderecoPorCep');
    this.viaCepService.obterEndereco(this.clienteFaturamento.cep).subscribe(
      (viaCep: ViaCep) => {
        this.clienteFaturamento.bairro = viaCep.bairro;
        this.clienteFaturamento.rua = viaCep.logradouro;
        this.estadoSelecionado = viaCep.uf;
        this.clienteFaturamento.ibge = viaCep.ibge;

        this.buscarCidades();

        this.focalizaNumero();

        this.carregandoService.esconde('buscaEnderecoPorCep');
      },
      (erro) => {
        this.carregandoService.esconde('buscaEnderecoPorCep');
        this.notificacaoService.erro('Não foi possível acessar o serviço de CEP!');
      }
    );
  }

  async buscarCidades(nomeCidade?: string) {
    try {
      this.carregandoService.mostra('buscaCidades');
      this.cidades = await this.ibgeService.consultarPorEstado(this.estadoSelecionado).toPromise();
      if (this.tipo !== 0 && !this.criandoPedidoSemValidacao) {
        if (nomeCidade) {
          this.cidadeSelcionado = this.cidades.find(
            (s) =>
              this.utilitarioService.remover_acentos_espaco(s.cidade.toLowerCase().trim()) ===
              this.utilitarioService.remover_acentos_espaco(nomeCidade.toLowerCase().trim())
          )
            ? this.cidades.find(
                (s) =>
                  this.utilitarioService.remover_acentos_espaco(s.cidade.toLowerCase().trim()) ===
                  this.utilitarioService.remover_acentos_espaco(nomeCidade.toLowerCase().trim())
              ).cod
            : undefined;
        } else {
          this.cidadeSelcionado = this.cidades.find((s) => s.cod === this.clienteFaturamento.ibge)
            ? this.cidades.find((s) => s.cod === this.clienteFaturamento.ibge).cod
            : '';
        }
      } else {
        this.cidadeSelcionado = this.cidades.find((s) => s.cod === this.cidadeSelcionado)
          ? this.cidadeSelcionado
          : null;
      }
    } catch (erro) {
      this.carregandoService.esconde('buscaCidades');
    } finally {
      this.carregandoService.esconde('buscaCidades');
    }
  }

  async buscarCidadeIntegrador() {
    try {
      this.carregandoService.mostra('buscarCidadeIntegrador');
      this.cidades = await this.ibgeService.consultarPorEstado(this.estadoSelecionado).toPromise();
      this.cidadeSelcionado = this.cidades.find((s) => s.cod === this.clienteIntegrador.ibge)
        ? this.cidades.find((s) => s.cod === this.clienteIntegrador.ibge).cod
        : '';
      await this.buscarFreteAutomatico();
    } catch (erro) {
    } finally {
      this.carregandoService.esconde('buscarCidadeIntegrador');
    }
  }

  focalizaNumero() {
    $('#numero').focus();
  }

  retornarDescontoFrete(percentual) {
    const descFrete =
      this.frete !== null && this.frete !== undefined && this.descontoFrete > percentual
        ? percentual
        : this.descontoFrete;
    return descFrete;
  }

  async alterouValorDoFrete(frete: Frete = new Frete()) {
    if ((this.freteManual || this.premissas.pVendEditarFrete) && this.tipoFrete === 0) {
      this.localizacao = 1;
      this.freteDigitado = true;
      this.alterou = true;

      if (frete !== null && frete !== undefined && frete.valorFrete !== 0) {
        if (this.verModalidades) {
          const valorOriginal = this.fretesOriginais.find((f) => f.id === frete.id).valorFrete;

          if (valorOriginal !== frete.valorFrete) {
            this.valorFrete = Number(frete.valorFrete);
          } else {
            this.freteDigitado = false;
            this.alterou = false;
          }
        }
      }

      if (this.premissasSistema.excluirCupomDescontoAoMudarValorFrete) {
        await this.excluirCupomDesconto();
      }

      await this.atualizaValores();
    }
  }

  validaFaixaDescarga() {
    let faixa: FaixaDescargaCIF = new FaixaDescargaCIF();

    if (this.faixasDescarga != null && this.faixasDescarga.length > 0) {
      if (this.itens != null && this.itens.length > 0) {
        this.itens.forEach((it) => {
          if (it.produtoTela.familia === 2) {
            faixa = this.faixasDescarga.find((f) => it.qt >= f.de && it.qt <= f.ate);

            if (faixa == null || faixa === undefined) {
              this.desabilitaDescargaCIF = true;
              this.tipoCIF = 0;
            } else {
              this.desabilitaDescargaCIF = false;
            }
          } else if (it.produtoTela.familia === 7) {
            it.produtoTela.composicao.forEach((c) => {
              if (c.produtoMP.familia === 2) {
                faixa = this.faixasDescarga.find((f) => c.qt * it.qt >= f.de && c.qt * it.qt <= f.ate);

                if (faixa == null || faixa === undefined) {
                  this.desabilitaDescargaCIF = true;
                  this.tipoCIF = 0;
                } else {
                  this.desabilitaDescargaCIF = false;
                }
              }
            });
          }
        });
      }
    } else {
      this.desabilitaDescargaCIF = true;
    }
  }

  private ultimosAvisosCalculo = '';

  // Exibe os avisos só quando mudam; enquanto os impostos seguem pendentes, o mesmo aviso não se repete a cada recálculo.
  private exibirAvisosCalculo(dadosCalculo: DadosCalculo) {
    const avisos = dadosCalculo.avisos || [];

    if (avisos.length === 0) {
      if (!dadosCalculo.impostosPendente) {
        this.ultimosAvisosCalculo = '';
      }

      return;
    }

    const chave = avisos.join('\n');

    if (chave === this.ultimosAvisosCalculo) return;

    this.ultimosAvisosCalculo = chave;
    avisos.forEach((a) => this.notificacaoService.aviso(a));
  }

  async atualizaValores(tipoCalculo: TipoCalculoPedido = TipoCalculoPedido.Normal, valorParaSimular?) {
    if (!this.podeAtualizarValores) {
      return;
    }

    if (
      this.frete !== null &&
      this.frete !== undefined &&
      this.frete.prazoTotal !== null &&
      this.frete.prazoTotal !== undefined
    ) {
      this.frete.prazoTotal = Number(this.frete.prazoTotal);
    } else {
      this.frete = new Frete();
      this.frete.prazoTotal = 0;
    }

    this.validaFaixaDescarga();

    let dadosCalculo: DadosCalculo = {
      valorProdutos: this.valorProdutos,
      valorServico: this.valorServico !== null && this.valorServico !== undefined ? Number(this.valorServico) : 0,
      valorDoServicoAcima: false,
      valorDa:
        tipoCalculo === TipoCalculoPedido.SimularDesconto
          ? valorParaSimular
          : this.valorDa !== null && this.valorDa !== undefined
            ? Number(this.valorDa)
            : 0,
      percentual: this.percentual !== null && this.percentual !== undefined ? Number(this.percentual) : 0,
      tipoFrete: this.tipoFrete,
      valorFrete: this.valorFrete !== null && this.valorFrete !== undefined ? Number(this.valorFrete) : 0,
      localizacao: this.localizacao !== undefined && this.localizacao !== null ? this.localizacao : 1,
      da: this.da,
      percentualFreteAvulso: this.percentualFreteAvulso,
      frete: this.frete,
      idDescarga: this.idDescarga,
      freteManual: this.freteManual,
      freteDigitado: this.freteDigitado,
      msgFreteIntegrador: '',
      mostrarMsgFreteIntegrador: false,
      descontoFrete: this.descontoFrete,
      taxaCondicao: this.taxaCondicao,
      valorTaxaCond: this.valorTaxaCond,
      valorTotal: this.valorTotal,
      valorServicoEntregaEditado: this.valorServicoEntregaEditado,
      servicoEntrega: this.servicoEntrega,
      valorServicoEntrega: this.valorServicoEntrega,
      valorProjeto: this.valorProjeto !== null && this.valorProjeto !== undefined ? Number(this.valorProjeto) : 0,
      seguros: [...this.segurosOriginais],
      segurosManuais: [...this.segurosManuais],
      segurosSelecionados: [...this.segurosSelecionados],
      segurosObrigatorios: [...this.segurosObrigatorios],
      segurosObrigatoriosRemovidos: [...this.segurosObrigatoriosRemovidos],
      potencia: this.potencia,
      idCupom: this.idCupom,
      valorSeguro: this.valorSeguro,
      valorLiquido: this.valorLiquido !== null && this.valorLiquido !== undefined ? Number(this.valorLiquido) : 0,
      valorProjetoLiquido:
        this.valorProjetoLiquido !== null && this.valorProjetoLiquido !== undefined
          ? Number(this.valorProjetoLiquido)
          : 0,
      voucher: this.voucher,
      dadosVoucher: this.dadosVoucher,
      valorVoucher: this.valorVoucher,
      alterou: this.alterou,
      origem: this.origem,
      pedidoFlag: 4,
      tipoCalculo: tipoCalculo,
      valorFinalParaSimular: tipoCalculo === TipoCalculoPedido.SimularValorFinal ? valorParaSimular : null,
      status: 0,
      qtModulos: this.qtModulos,
      tipoCIF: this.tipoCIF !== null && this.tipoCIF !== undefined ? this.tipoCIF : 0,
      selecionarSegurosPreSelecionaveis: this.selecionarSegurosPreSelecionaveis,
      itens: this.itens,
      ipi: this.ipi,
      ibs: this.ibs,
      cbs: this.cbs,
      multiFormaPagamento: this.usandoMultiFormasPagamento,
      formasPagamento: this.formasPagamento,
      possuiArredondamento: this.usandoArredondamento,
      cpfCnpj: this.vendaDireta
        ? this.clienteFaturamento.tipo === 0
          ? this.clienteFaturamento.cnpj
          : this.clienteFaturamento.cpf
        : this.clienteIntegrador.tipo === 0
          ? this.clienteIntegrador.cnpj
          : this.clienteIntegrador.cpf,
      idCd: this.idCD,
      uf: this.enderecoEntrega.uf,
      impostos: this.impostos,
      valorImpostos: this.valorImpostos,
      impostosPendente: this.impostosPendente,
      calcularImpostosApi: true,
      descontoIndividual: this.descontoIndividual
    };

    try {
      this.carregandoService.limpaProgresso();
      this.carregandoService.mostraProgresso();

      // Com alterou e taxa 0 o cálculo já zera a taxa; evita reprocessar se mesmo assim ela voltar.
      const calculouSemTaxa = dadosCalculo.alterou && Number(dadosCalculo.taxaCondicao) === 0;

      dadosCalculo = await this.pedidoService.calcular(dadosCalculo).toPromise();
      this.exibirAvisosCalculo(dadosCalculo);

      if (dadosCalculo.valorDoServicoAcima) {
        swal({
          title: 'ATENÇÃO!!!',
          html:
            'Valor do serviço acima do permitido!!!<br>Limite: ' +
            ((this.valorProdutos * this.premissas.limiteRepasse) / 100).toLocaleString(),
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-warning',
          type: 'warning'
        }).catch(swal.noop);
      }

      const deveLimparLocalizacao = this.premissasSistema.habilitaValidacaoLocalizacao && !this.selecionouLocalizacao;

      switch (tipoCalculo) {
        case TipoCalculoPedido.SimularDesconto:
          return dadosCalculo.valorTotal;

        case TipoCalculoPedido.SimularValorFinal:
          return dadosCalculo.valorDa;

        case TipoCalculoPedido.Normal:
          {
            this.valorProdutos = Number(dadosCalculo.valorProdutos.toFixed(2));
            this.valorServico = dadosCalculo.valorServico;
            this.valorDa = dadosCalculo.valorDa;
            this.percentual = dadosCalculo.percentual;
            this.tipoFrete = dadosCalculo.tipoFrete;
            this.valorFrete = dadosCalculo.valorFrete;
            this.localizacao = deveLimparLocalizacao ? null : dadosCalculo.localizacao;
            this.da = dadosCalculo.da;
            this.percentualFreteAvulso = dadosCalculo.percentualFreteAvulso;
            this.frete = dadosCalculo.frete;
            this.idDescarga = dadosCalculo.idDescarga;
            this.freteManual = dadosCalculo.freteManual;
            this.freteDigitado = dadosCalculo.freteDigitado;
            this.msgFreteIntegrador = dadosCalculo.msgFreteIntegrador;
            this.mostrarMsgFreteIntegrador = dadosCalculo.mostrarMsgFreteIntegrador;
            this.descontoFrete = dadosCalculo.descontoFrete;
            this.taxaCondicao = dadosCalculo.taxaCondicao;
            this.valorTaxaCond = dadosCalculo.valorTaxaCond;
            this.valorTotal = Number(dadosCalculo.valorTotal.toFixed(2));
            this.valorServicoEntregaEditado = dadosCalculo.valorServicoEntregaEditado;
            this.servicoEntrega = dadosCalculo.servicoEntrega;
            this.valorServicoEntrega = dadosCalculo.valorServicoEntrega;
            this.valorProjeto = dadosCalculo.valorProjeto;
            this.seguros = [...dadosCalculo.seguros];
            this.segurosManuais = [...dadosCalculo.segurosManuais];
            this.segurosSelecionados = [...dadosCalculo.segurosSelecionados];
            this.segurosObrigatorios = [...dadosCalculo.segurosObrigatorios];
            this.segurosObrigatoriosRemovidos = [...dadosCalculo.segurosObrigatoriosRemovidos];
            this.potencia = dadosCalculo.potencia;
            this.idCupom = dadosCalculo.idCupom;
            this.valorSeguro = dadosCalculo.valorSeguro;
            this.valorLiquido = dadosCalculo.valorLiquido;
            this.valorProjetoLiquido = dadosCalculo.valorProjetoLiquido;
            this.voucher = dadosCalculo.voucher;
            this.dadosVoucher = dadosCalculo.dadosVoucher;
            this.valorVoucher = dadosCalculo.valorVoucher;
            this.origem = dadosCalculo.origem;
            this.selecionarSegurosPreSelecionaveis = dadosCalculo.selecionarSegurosPreSelecionaveis;
            this.ipi = dadosCalculo.ipi;
            this.ibs = dadosCalculo.ibs;
            this.cbs = dadosCalculo.cbs;
            const valorAnteriorParaFormasPagamento = this.valorParaFormasPagamento;
            this.formasPagamento = dadosCalculo.formasPagamento;
            this.valorParaFormasPagamento = dadosCalculo.valorParaFormasPagamento;
            this.normalizarFormasPagamentoAposAlteracao(valorAnteriorParaFormasPagamento);
            this.impostos = dadosCalculo.impostos;
            this.valorImpostos = dadosCalculo.valorImpostos;
            this.impostosPendente = dadosCalculo.impostosPendente;

            if (this.alterou && this.valorTotalFixo !== this.valorTotal) {
              this.valorTotalFixo = null;
            }

            if (
              this.premissasSistema.usarModalidade &&
              this.fretes !== null &&
              this.fretes !== undefined &&
              this.fretes.length > 0
            ) {
              for (let f of this.fretes) {
                f = await this.valoresFretes(f, TipoCalculoPedido.Normal);
              }

              this.fretes = this.fretes.filter((f) => f.valorFrete !== 0 && f.prazoTotal !== 0);
              this.fretesOriginais = JSON.parse(JSON.stringify(this.fretes));
            }

            if (this.premissas.usarSeguro) {
              const valorTotal =
                this.valorTotalFixo === null || this.valorTotalFixo === undefined
                  ? this.valorTotal === null || this.valorTotal === undefined
                    ? 0
                    : this.valorTotal
                  : this.valorTotalFixo;

              this.seguros = this.seguros.filter((s) => s.valorMinimo <= valorTotal);
            }

            if (this.multiFormaPagamentoComp) {
              this.changeDetectorRef.detectChanges();
              await this.multiFormaPagamentoComp.salvarTodos();
            }

            // Forma/condição zerada sem passar pelo Calcular: recalcula com a taxa 0.
            if (!calculouSemTaxa && this.possuiTaxaSemCondicao()) {
              this.alterou = true;
              await this.atualizarTaxaDeCondicao();
            }
          }
          break;

        default:
          break;
      }

      this.usandoArredondamento = false;

      this.buscaValorMarkup();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.escondeProgresso();
    }
  }

  private normalizarFormasPagamentoAposAlteracao(valorAnterior: number): void {
    const formasPagamento = this.formasPagamento;
    const valorAtual = Number(this.valorParaFormasPagamento);

    if (
      this.usandoArredondamento ||
      !this.premissas.podeUsarMultiFormaPagamento ||
      !this.alterou ||
      Number(valorAnterior) === valorAtual ||
      !formasPagamento
    ) {
      return;
    }

    const primeiraFormaPagamento = formasPagamento[0];

    primeiraFormaPagamento.tipo = TipoVendaFormaPag.Variavel;
    primeiraFormaPagamento.idFormaPag = null;
    primeiraFormaPagamento.idCondPag = null;
    primeiraFormaPagamento.valor = 0;
    primeiraFormaPagamento.taxa = 0;
    primeiraFormaPagamento.valorTaxa = 0;
    primeiraFormaPagamento.rateio = 0;
    primeiraFormaPagamento.valorRateio = 0;
    primeiraFormaPagamento.total = 0;
    formasPagamento.splice(0, formasPagamento.length, primeiraFormaPagamento);

    if (this.multiFormaPagamentoComp) {
      this.changeDetectorRef.detectChanges();
      this.multiFormaPagamentoComp.recarregarFormasPagamentoPrimeiraForma();
    }
  }

  alterouValorServico() {
    this.alterou = true;

    this.recalculaFreteManual();

    if (this.multiFormaPagamentoComp) {
      this.changeDetectorRef.detectChanges();
      this.multiFormaPagamentoComp.recarregarFormasPagamentoPrimeiraForma();
    }
  }

  async atualizaDesconto(campo, veioDaSimulacao?) {
    if (!this.checandoDesconto) {
      this.checandoDesconto = true;

      let percentualCalculado = 0;
      const valorDaMaximo = Number(((Number(this.valorProdutos) * this.descontoMaximo) / 100).toFixed(2));

      // if (this.descontoIndividual) {
      //   this.valorDa = Number((this.valorProdutos - (this.itens.reduce((acc, curr) => (acc + curr.vTotal), 0))).toFixed(2));
      //   campo = 1;
      // }

      if (campo === 0) {
        // contra prova
        const percentualCalculadoTemp = (this.valorDa * 100) / Number(this.valorProdutos);

        let percentualTemp = veioDaSimulacao
          ? percentualCalculadoTemp === 0
            ? 0
            : Number(percentualCalculadoTemp.toFixed(4)) === 0
              ? 0.0001
              : Number(percentualCalculadoTemp.toFixed(4))
          : Number(percentualCalculadoTemp.toFixed(2));

        if (percentualTemp > this.descontoMaximo && Number(this.valorDa) <= valorDaMaximo) {
          percentualTemp =
            percentualCalculadoTemp > this.descontoMaximo ? this.descontoMaximo : percentualCalculadoTemp;
        }

        if (this.percentual !== percentualTemp || this.alterouValorProdutos) {
          this.valorDa = Number(((Number(this.valorProdutos) * this.percentual) / 100).toFixed(2));
        }
      } else {
        percentualCalculado = (this.valorDa * 100) / Number(this.valorProdutos);

        this.percentual = veioDaSimulacao
          ? percentualCalculado === 0
            ? 0
            : Number(percentualCalculado.toFixed(4)) === 0
              ? 0.0001
              : Number(percentualCalculado.toFixed(4))
          : Number(percentualCalculado.toFixed(2));

        if (
          this.descontoIndividual &&
          this.utilitarioService.compararDescontos(percentualCalculado, this.descontoMaximo)
        ) {
          this.percentual = this.descontoMaximo;
          percentualCalculado = this.descontoMaximo;
        }

        if (this.percentual > this.descontoMaximo && Number(this.valorDa) <= valorDaMaximo) {
          this.percentual = percentualCalculado > this.descontoMaximo ? this.descontoMaximo : percentualCalculado;
        }
      }

      if (
        this.da === 0 &&
        (campo === 0 ? this.percentual : percentualCalculado) > this.descontoMaximo &&
        this.valorDa > valorDaMaximo
      ) {
        this.alterou = true;

        if (!this.integrador) {
          let texto = this.premissas.descClienteSobreporVendedor
            ? `Desconto acima do permitido: <b> <br/> INTEGRADOR: ${this.clienteIntegrador.descontoMaximoGI}%`
            : `Desconto acima do permitido: <b> ${this.descontoMaximo.toLocaleString()}% </b><br/>Vendedor: ${
                this.idCupom === null || this.idCupom === undefined ? this.usuarioLogado.limDesc : this.limDesc
              }% <br/> Integrador: ${this.clienteIntegrador.descontoMaximoGI}%`;

          if (this.cupomDesconto != null) {
            texto += ` <br/>Cupom de Desconto: ${this.cupomDesconto}`;
          }

          this.carregandoService.zera();

          await swal({
            title: 'ATENÇÃO!!',
            html: texto,
            type: 'warning',
            confirmButtonClass: 'btn btn-warning',
            buttonsStyling: false,
            allowEnterKey: false
          });

          this.percentual = this.descontoMaximo;
          this.valorDa = Number(((Number(this.valorProdutos) * this.percentual) / 100).toFixed(2));
          await this.atualizaValores();
          this.checandoDesconto = false;
        } else {
          this.percentual = this.descontoMaximo;
          this.valorDa = Number(((Number(this.valorProdutos) * this.percentual) / 100).toFixed(2));
          await this.atualizaValores();
          this.checandoDesconto = false;
        }
      } else {
        await this.atualizaValores();
        this.checandoDesconto = false;
      }
    }
  }

  async buscarFrete() {
    try {
      this.carregandoService.mostra('buscarFrete');

      if (this.premissasSistema.usarModalidade && !this.freteManual) {
        this.fretes = (await this.freteService.listarPorIbge(this.enderecoEntrega.ibge, this.idCD).toPromise()) || [];

        // if (this.contadorInicializacao === 0 && this.idFrete && !this.fretes.some((b) => b.id === this.idFrete)) {
        //   const freteSelecionado: Frete = await this.freteService.consultarPorIdFrete(this.idFrete).toPromise();

        //   if (!this.fretes.includes(freteSelecionado)) {
        //     this.fretes.push(freteSelecionado);
        //   }

        //   this.contadorInicializacao++;
        // }

        this.fretes = this.fretes.filter((f) => f.valorFrete !== 0 && f.prazoTotal !== 0);
        this.verModalidades = this.fretes !== null && this.fretes !== undefined && this.fretes.length > 0;

        if (this.verModalidades) {
          if (this.idFrete !== null && this.idFrete !== undefined) {
            this.frete = this.fretes.find((f) => f.id === this.idFrete);

            if (this.frete === undefined || this.frete === null) {
              this.selecionarFretePadrao();
            }
          } else {
            this.selecionarFretePadrao();
          }

          for (let f of this.fretes) {
            f = await this.valoresFretes(f, TipoCalculoPedido.Normal);
          }

          this.fretesOriginais = JSON.parse(JSON.stringify(this.fretes));
        }
      }

      if (
        (!this.verModalidades || this.freteManual) &&
        this.enderecoEntrega.ibge !== null &&
        this.enderecoEntrega.ibge !== undefined &&
        this.enderecoEntrega.ibge &&
        !isNaN(this.enderecoEntrega.ibge)
      ) {
        this.frete = await this.freteService.buscarPorIbge(this.enderecoEntrega.ibge, this.idCD).toPromise();
      }

      if (this.alterou) {
        if (this.idFrete != this.frete.id && this.premissasSistema.excluirCupomDescontoAoMudarValorFrete) {
          await this.excluirCupomDesconto();
        }
      }

      // if (this.frete !== undefined && this.frete !== null && this.frete.somenteFOB === 1) {
      //   this.tipoFrete = 1;
      //   this.tipoCIF = -1;
      // } else

      this.validarTipoFrete(true);

      if (this.tipoFrete === undefined) {
        this.tipoFrete = 0;
      }

      this.freteDigitado = this.freteManualInicial;
      this.freteManualInicial = false;

      await this.buscarPerguntasEntrega();

      await this.atualizaValores();

      if (
        this.tipoFrete === 0 &&
        !this.podeAlterarCD &&
        this.premissas.pCentroDistribuicao &&
        this.premissasSistema.habilitarCDPorCidade &&
        this.ibgeEntrega &&
        this.ibgeEntrega.cd !== this.idCD &&
        Number(this.ibgeEntrega.cod) !== Number(this.cidadeOriginal)
      ) {
        swal({
          title: 'ATENÇÃO!!!',
          html: 'Este produto não atende à nova cidade escolhida. Refaça o pedido com a cidade desejada. Temos outros produtos disponíveis. Caso precise, entre em contato com seu consultor.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-warning',
          type: 'warning'
        });
      }
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarFrete');
    }
  }

  validarTipoFrete(mostrarMsg: boolean): boolean {
    if (
      ((this.frete !== undefined && this.frete !== null && this.frete.somenteFOB === 1) ||
        (this.integrador && this.premissas.pFreteManualAvulso && this.origem === 2)) &&
      this.tipoFrete === 0
    ) {
      if (mostrarMsg) {
        this.exibirMensagemSomenteFob();
      }

      return false;
    }

    return true;
  }

  private async exibirMensagemSomenteFob(): Promise<void> {
    if (this.exibindoMensagemSomenteFob) {
      return;
    }

    this.exibindoMensagemSomenteFob = true;

    try {
      await swal({
        title: 'ATENÇÃO!!!',
        html: 'O endereço escolhido não permite entrega CIF!<br/>Escolha outro endereço ou selecione FOB (retirada)!!!',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-warning',
        type: 'warning'
      }).catch(swal.noop);
    } finally {
      this.exibindoMensagemSomenteFob = false;
    }
  }

  private selecionarFretePadrao(): void {
    if (this.fretes.some((f) => f.somenteFOB)) {
      const freteFOB = this.fretes.find((f) => f.somenteFOB);
      this.frete = freteFOB || new Frete();
    } else {
      const freteValido = this.fretes.find((f) => f.valorFrete !== 0 && f.prazoTotal !== 0 && f.modalidadePadrao);

      if (freteValido) {
        this.frete = freteValido;
      } else {
        const freteComValor = this.fretes.find((f) => f.valorFrete !== 0 && f.prazoTotal !== 0);
        this.frete = freteComValor || new Frete();
      }
    }
  }

  async valoresFretes(frete: Frete, tipoCalculo: TipoCalculoPedido = TipoCalculoPedido.Normal) {
    frete.valorFrete = frete.valorFrete === null || frete.valorFrete === undefined ? 0 : frete.valorFrete;
    frete.prazoTotal = Number(frete.prazoTotal);

    let dadosCalculo: DadosCalculo = {
      valorProdutos: this.valorProdutos,
      valorServico: this.valorServico !== null && this.valorServico !== undefined ? Number(this.valorServico) : 0,
      valorDoServicoAcima: false,
      valorDa: this.valorDa !== null && this.valorDa !== undefined ? Number(this.valorDa) : 0,
      percentual: this.percentual !== null && this.percentual !== undefined ? Number(this.percentual) : 0,
      tipoFrete: this.tipoFrete,
      valorFrete: frete.valorFrete !== null && frete.valorFrete !== undefined ? Number(frete.valorFrete) : 0,
      localizacao: this.localizacao !== undefined && this.localizacao !== null ? this.localizacao : 1,
      da: this.da,
      percentualFreteAvulso: this.percentualFreteAvulso,
      frete: frete,
      idDescarga: this.idDescarga,
      freteManual: this.freteManual,
      freteDigitado: this.freteDigitado,
      msgFreteIntegrador: '',
      mostrarMsgFreteIntegrador: false,
      descontoFrete: this.descontoFrete,
      taxaCondicao: this.taxaCondicao,
      valorTaxaCond: this.valorTaxaCond,
      valorTotal: this.valorTotal,
      valorServicoEntregaEditado: this.valorServicoEntregaEditado,
      servicoEntrega: this.servicoEntrega,
      valorServicoEntrega: this.valorServicoEntrega,
      valorProjeto: this.valorProjeto !== null && this.valorProjeto !== undefined ? Number(this.valorProjeto) : 0,
      seguros: [...this.seguros],
      segurosManuais: [...this.segurosManuais],
      segurosSelecionados: [...this.segurosSelecionados],
      segurosObrigatorios: [...this.segurosObrigatorios],
      segurosObrigatoriosRemovidos: [...this.segurosObrigatoriosRemovidos],
      potencia: this.potencia,
      idCupom: this.idCupom,
      valorSeguro: this.valorSeguro,
      valorLiquido: this.valorLiquido !== null && this.valorLiquido !== undefined ? Number(this.valorLiquido) : 0,
      valorProjetoLiquido:
        this.valorProjetoLiquido !== null && this.valorProjetoLiquido !== undefined
          ? Number(this.valorProjetoLiquido)
          : 0,
      voucher: this.voucher,
      dadosVoucher: this.dadosVoucher,
      valorVoucher: this.valorVoucher,
      alterou: true,
      origem: this.origem,
      pedidoFlag: 4,
      tipoCalculo: tipoCalculo,
      valorFinalParaSimular: null,
      status: 0,
      qtModulos: this.qtModulos,
      tipoCIF: this.tipoCIF !== null && this.tipoCIF !== undefined ? this.tipoCIF : 0,
      itens: this.itens,
      ipi: this.ipi,
      ibs: this.ibs,
      cbs: this.cbs,
      multiFormaPagamento: false,
      formasPagamento: this.formasPagamento,
      possuiArredondamento: this.usandoArredondamento,
      cpfCnpj: this.vendaDireta
        ? this.clienteFaturamento.tipo === 0
          ? this.clienteFaturamento.cnpj
          : this.clienteFaturamento.cpf
        : this.cliente.tipo === 0
          ? this.cliente.cnpj
          : this.cliente.cpf,
      idCd: this.idCD,
      uf: this.enderecoEntrega.uf,
      impostos: this.impostos,
      valorImpostos: this.valorImpostos,
      impostosPendente: this.impostosPendente,
      calcularImpostosApi: true,
      descontoIndividual: this.descontoIndividual
    };

    try {
      this.carregandoService.limpaProgresso();
      this.carregandoService.mostraProgresso();
      const resultado = await this.pedidoService.calcular(dadosCalculo).toPromise();
      frete.valorFrete = resultado.valorFrete;
    } catch (erro) {
      this.notificacaoService.erro(erro);
      frete.valorFrete = 0;
    } finally {
      this.carregandoService.escondeProgresso();
      return frete;
    }
  }

  async selecionarFreteModalidade(frete: Frete) {
    this.frete = frete;
    this.alterou = true;

    await this.buscarPerguntasEntrega();
    await this.atualizaValores();
  }

  async alteraFrete() {
    await this.buscarFrete();
  }

  async alteraFrete2() {
    if (this.tipoFrete === 0) {
      this.valorFrete = Number(this.valorFrete);
    }

    if (this.premissasSistema.usaDescargaCif) {
      if (this.tipoFrete === 1) {
        this.tipoCIF = 0;

        if (this.premissasSistema.habilitaValidacaoLocalizacao) {
          this.alterou = true;
          this.localizacao = 1;
          this.selecionouLocalizacao = true;
          this.atualizaValores();
        }
      } else if (this.tipoCIF != null) {
        this.tipoCIF = null;

        if (this.premissasSistema.habilitaValidacaoLocalizacao && this.localizacao !== null) {
          this.localizacao = null;
          this.selecionouLocalizacao = false;
        }
      }
    } else {
      if (this.premissasSistema.habilitaValidacaoLocalizacao) {
        if (this.tipoFrete === 1) {
          this.alterou = true;
          this.localizacao = 1;
          this.selecionouLocalizacao = true;
          this.atualizaValores();
        } else if (this.localizacao !== null) {
          this.localizacao = null;
          this.selecionouLocalizacao = false;
        }
      }
    }

    if (this.premissasSistema.excluirCupomDescontoAoMudarTipoFrete) {
      await this.excluirCupomDesconto();
    }

    await this.buscarFrete();

    await this.defineEnderecoEntregaFob();
  }

  async recalculaFreteManual() {
    if (this.premissasSistema.recalculaFreteManual) {
      await this.buscarFrete();
    }
  }

  async alterouCidade() {
    await this.buscarFreteAutomatico();
  }

  async buscarFreteAutomatico() {
    if (
      (this.tipo === 0 || this.criandoPedidoSemValidacao) &&
      !this.vendaDireta &&
      !this.bloquearTipoFreteVendaDireta
    ) {
      this.enderecoEntrega = new VendaEntrega();
      this.enderecoEntrega.tipoEndereco = TipoEnderecoEntrega.NaoInformado;
      this.enderecoEntrega.uf = this.estadoSelecionado;
      this.enderecoEntrega.ibge = this.cidadeSelcionado;

      this.ibgeEntrega =
        this.cidadeSelcionado !== null && this.cidadeSelcionado !== undefined
          ? this.cidades.find((s) => s.cod === this.enderecoEntrega.ibge.toString())
          : undefined;

      this.enderecoEntrega.cidade = this.ibgeEntrega ? this.ibgeEntrega.cidade : '';

      this.definirCamposInvalidosEnderecoEntrega();
      await this.alteraFrete();
      await this.atualizarDescontoPrecificacaoUF();
    } else {
      if (this.enderecoEntrega !== null && this.enderecoEntrega !== undefined) {
        this.ibgeEntrega = this.enderecoEntrega.ibge
          ? await this.ibgeService.buscarCidadePorCodIGBE(this.enderecoEntrega.ibge.toString()).toPromise()
          : undefined;
        await this.alteraFrete();
      }
    }
  }

  async buscarServicosEntrega() {
    try {
      this.carregandoService.mostra('buscarServicoEntrega');
      this.servicosEntrega = await this.servicoEntregaService.consultarListaServicosEntrega().toPromise();
    } catch (err) {
      this.notificacaoService.erro(err);
    } finally {
      this.carregandoService.esconde('buscarServicoEntrega');
    }
  }

  async buscarSeguros() {
    try {
      this.carregandoService.mostra('buscarSeguros');
      this.seguros = await this.seguroService.consultarLista(this.idCupom).toPromise();

      if (this.origem === 2) {
        this.seguros = this.seguros.filter((p) => p.apareceAvulso);
      } else if (this.origem === 3) {
        this.seguros = this.seguros.filter((p) => p.apareceLojaProduto);
      }

      this.segurosOriginais = JSON.parse(JSON.stringify(this.seguros));

      this.seguros.forEach((p) => {
        if (p.valor === null) {
          p.valor = 0;
        }
      });
    } catch (err) {
      this.notificacaoService.erro(err);
    } finally {
      this.carregandoService.esconde('buscarSeguros');
    }
  }

  async buscarMsgEnderecoAdicional() {
    this.carregandoService.mostra('buscaMsgEnderecoAdicional');
    this.premissasService.consultarMsgEnderecoAdicional().subscribe(
      (f) => {
        this.msgEnderecoAdicional = f.valor;
        this.carregandoService.esconde('buscaMsgEnderecoAdicional');
      },
      (erro) => {
        this.carregandoService.esconde('buscaMsgEnderecoAdicional');
        this.notificacaoService.erro(erro);
      }
    );
  }

  async atualizarTaxaDeCondicao() {
    if (this.usandoMultiFormasPagamento || !this.pedidoComCondicaoDePagamento()) {
      this.taxaCondicao = 0;
    } else {
      this.taxaCondicao = this.formasPagamento[0].taxa;
    }
    await this.atualizaValores();
  }

  adicionarEnderecoEntrega() {
    const novoEnderecoDeEntrega =
      this.enderecoEntrega.tipoEndereco === TipoEnderecoEntrega.Personalizado
        ? Object.assign({}, this.enderecoEntrega)
        : new VendaEntrega();
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(VendaEnderecoModalComponent, {
      width: largura > 1100 ? '1000px' : $('body').width().toString() + 'px',
      // passa os produtos já selecionados
      data: {
        enderecoEntrega: novoEnderecoDeEntrega,
        mostrarDadosPessoa: this.tipo === 1 && !this.criandoPedidoSemValidacao,
        validarDadosPessoa: this.tipo === 1 && !this.criandoPedidoSemValidacao,
        msgEnderecoAdicional: this.msgEnderecoAdicional
      },
      panelClass: 'modal-card',
      maxHeight: '95vh'
    });
    dialogRef.afterClosed().subscribe(async (result: VendaEntrega) => {
      if (result) {
        this.enderecoEntrega = result;

        this.mostraMsgEnderecoAdicional = true;

        this.alterou = true;

        this.gerarEnderecoEntregaCompleto();
        this.definirCamposInvalidosEnderecoEntrega();
        await this.buscarFreteAutomatico();

        this.enderecoEntregaNovo = this.enderecoEntrega;
        this.camposInvalidosEnderecoEntregaNovo = this.camposInvalidosEnderecoEntrega;

        await this.atualizarDescontoPrecificacaoUF();
      } else {
        if (this.enderecoEntrega.tipoEndereco !== TipoEnderecoEntrega.Personalizado) {
          this.enderecoEntrega = new VendaEntrega();
        }

        this.gerarEnderecoEntregaCompleto();
        this.definirCamposInvalidosEnderecoEntrega();
        await this.atualizarDescontoPrecificacaoUF();
      }
    });
  }

  abrirDadosVendaDireta(tipo) {
    if (tipo === 1) {
      if (!this.vendaDireta) {
        this.alterou = true;
        this.clienteFaturamento = undefined;

        if (
          this.clienteIntegrador !== undefined &&
          this.enderecoEntrega.tipoEndereco === TipoEnderecoEntrega.VendaDireta
        ) {
          this.completarEnderecoEntrega(true, true).then();
        }

        if (this.origem === 3 && this.premissasSistema.habilitarApiImposto) {
          this.atualizaValores().then();
        }

        return;
      }
    }

    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(VendaDiretaModalComponent, {
      width: largura > 1100 ? '1000px' : $('body').width().toString() + 'px',
      // passa os produtos já selecionados
      data: {
        clienteFaturamento:
          this.clienteFaturamento === null || this.clienteFaturamento === undefined
            ? new Cliente()
            : Object.assign({}, this.clienteFaturamento)
      },
      panelClass: 'modal-card',
      maxHeight: '95vh'
    });
    dialogRef.afterClosed().subscribe((result: Cliente) => {
      if (result) {
        this.clienteFaturamento = result;

        if (this.clienteFaturamento.cep === null || this.clienteFaturamento.cep === undefined) {
          this.vendaDireta = false;
        } else {
          if (!this.clienteFaturamento.salvar) {
            this.alterou = true;
          }

          this.clienteFaturamento.salvar = true;

          if (this.tipoEnderecoSelecionado !== TipoEnderecoEntrega.VendaDireta) {
            this.completarEnderecoEntrega(false, true).then();
          } else {
            this.copiaEnderecoVendaDireta().then();
          }
        }

        if (this.origem === 3 && this.premissasSistema.habilitarApiImposto) {
          this.atualizaValores().then();
        }
      } else {
        if (
          this.clienteFaturamento === null ||
          this.clienteFaturamento === undefined ||
          this.clienteFaturamento.cep === null ||
          this.clienteFaturamento.cep === undefined
        ) {
          this.vendaDireta = false;
          this.clienteFaturamento = undefined;
        }
      }
    });
  }

  async buscarEnderecoDeEntrega() {
    try {
      this.carregandoService.mostra('buscarEnderecoDeEntrega');
      if (this.idCupom) {
        this.enderecoEntrega = await this.pedidoService.buscarEnderecoDeEntrega(this.idCupom).toPromise();
        this.cidadeOriginal = this.enderecoEntrega.ibge.toString();
      } else if (!this.enderecoEntrega) {
        if (!this.cidadeSelcionado && !this.estadoSelecionado && this.cliente && this.cliente.ibge && this.cliente.uf) {
          this.cidadeSelcionado = this.cliente.ibge;
          this.estadoSelecionado = this.cliente.uf;
        }

        await this.completarEnderecoEntrega(true, this.alterou);
        await this.atualizarDescontoPrecificacaoUF();
      }

      if (this.enderecoEntrega) {
        this.gerarEnderecoEntregaCompleto();

        if (!this.enderecoEntrega.cep || !this.enderecoEntrega.tipoEndereco) {
          this.enderecoEntrega.tipoEndereco = TipoEnderecoEntrega.NaoInformado;
          this.tipoEnderecoSelecionado = TipoEnderecoEntrega.NaoInformado;
        } else {
          this.tipoEnderecoSelecionado = this.enderecoEntrega.tipoEndereco;
        }

        await this.completarEnderecoEntrega(false, this.alterou);
        await this.atualizarDescontoPrecificacaoUF();
        await this.buscarFreteAutomatico();
      } else {
        await this.completarEnderecoEntrega(true, this.alterou);
      }

      this.definirCamposInvalidosEnderecoEntrega();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarEnderecoDeEntrega');
    }
  }

  async copiaEnderecoVendaDireta() {
    this.enderecoEntrega = new VendaEntrega();
    this.enderecoEntrega.tipoEndereco = TipoEnderecoEntrega.VendaDireta;
    this.enderecoEntrega.rua = this.clienteFaturamento.rua;
    this.enderecoEntrega.numero = this.clienteFaturamento.n;
    this.enderecoEntrega.bairro = this.clienteFaturamento.bairro;
    this.enderecoEntrega.cidade = this.clienteFaturamento.cidade;
    this.enderecoEntrega.cep = this.clienteFaturamento.cep;
    this.enderecoEntrega.uf = this.clienteFaturamento.uf;
    this.enderecoEntrega.complemento = this.clienteFaturamento.compl;
    this.enderecoEntrega.ibge = Number(this.clienteFaturamento.ibge);
    this.enderecoEntrega.tipo = this.clienteFaturamento.tipo;
    this.enderecoEntrega.cpfCnpj =
      this.clienteFaturamento.tipo === 1 ? this.clienteFaturamento.cpf : this.clienteFaturamento.cnpj;
    this.enderecoEntrega.rgIe =
      this.clienteFaturamento.tipo === 1 ? this.clienteFaturamento.rg : this.clienteFaturamento.inscEst;
    this.enderecoEntrega.nome = this.clienteFaturamento.nome;
    this.enderecoEntrega.celular = this.clienteFaturamento.cel;
    this.enderecoEntrega.email = this.clienteFaturamento.email;

    this.gerarEnderecoEntregaCompleto();
    await this.buscarFreteAutomatico();
    await this.atualizarDescontoPrecificacaoUF();

    this.definirCamposInvalidosEnderecoEntrega();
  }

  async copiaEnderecoIntegrador() {
    this.enderecoEntrega = new VendaEntrega();
    this.enderecoEntrega.tipoEndereco = TipoEnderecoEntrega.Integrador;
    this.enderecoEntrega.rua = this.clienteIntegrador.rua;
    this.enderecoEntrega.numero = this.clienteIntegrador.n;
    this.enderecoEntrega.bairro = this.clienteIntegrador.bairro;
    this.enderecoEntrega.cidade = this.clienteIntegrador.cidade;
    this.enderecoEntrega.cep = this.clienteIntegrador.cep;
    this.enderecoEntrega.uf = this.clienteIntegrador.uf;
    this.enderecoEntrega.complemento = this.clienteIntegrador.compl;
    this.enderecoEntrega.ibge = Number(this.clienteIntegrador.ibge);

    this.enderecoEntrega.tipo = this.clienteIntegrador.tipo;
    this.enderecoEntrega.cpfCnpj =
      this.clienteIntegrador.tipo === 1 ? this.clienteIntegrador.cpf : this.clienteIntegrador.cnpj;
    this.enderecoEntrega.rgIe =
      this.clienteIntegrador.tipo === 1 ? this.clienteIntegrador.rg : this.clienteIntegrador.inscEst;
    this.enderecoEntrega.nome = this.clienteIntegrador.nome;
    this.enderecoEntrega.celular = this.clienteIntegrador.cel;
    this.enderecoEntrega.email = this.clienteIntegrador.email;

    if (this.tipoEnderecoSelecionado !== this.enderecoEntrega.tipoEndereco) {
      this.tipoEnderecoSelecionado = this.enderecoEntrega.tipoEndereco;
    }

    this.gerarEnderecoEntregaCompleto();
    await this.buscarFreteAutomatico();
    await this.atualizarDescontoPrecificacaoUF();
    this.definirCamposInvalidosEnderecoEntrega();
  }

  async copiaEnderecoNovo() {
    if (this.enderecoEntregaNovo !== undefined) {
      this.enderecoEntrega = this.enderecoEntregaNovo;
      this.camposInvalidosEnderecoEntrega = this.camposInvalidosEnderecoEntregaNovo;

      this.gerarEnderecoEntregaCompleto();
      await this.buscarFreteAutomatico();
    } else {
      this.adicionarEnderecoEntrega();
    }

    await this.atualizarDescontoPrecificacaoUF();
  }

  async buscarUFCidadeIntegrador(idIntegrador?) {
    try {
      this.carregandoService.mostra('buscarUFCidadeIntegrador');
    } catch (erro) {
      this.clienteIntegrador = this.premissasUsuario.atualizaDadosReceitaIntegrador
        ? await this.clienteService.consultarAtualizadoReceita(this.usuarioLogado.id, true).toPromise()
        : await this.clienteService.consultarPorIdCliente(this.usuarioLogado.id, true).toPromise();

      this.estadoSelecionado = this.clienteIntegrador.uf;
      await this.buscarCidadeIntegrador();
    } finally {
      this.carregandoService.esconde('buscarUFCidadeIntegrador');
    }
  }

  definirCamposInvalidosEnderecoEntrega() {
    const camposInvalidos = [];

    if (this.enderecoEntrega !== undefined && this.enderecoEntrega !== null) {
      if (this.enderecoEntrega.cep === null || this.enderecoEntrega.cep === undefined) {
        camposInvalidos.push('CEP');
      }
      if (this.enderecoEntrega.cidade === null || this.enderecoEntrega.cidade === undefined) {
        camposInvalidos.push('CIDADE');
      }
      if (this.enderecoEntrega.uf === null || this.enderecoEntrega.uf === undefined) {
        camposInvalidos.push('UF');
      }
      if (this.enderecoEntrega.rua === null || this.enderecoEntrega.rua === undefined) {
        camposInvalidos.push('LOGRADOURO');
      }
      if (this.enderecoEntrega.bairro === null || this.enderecoEntrega.bairro === undefined) {
        camposInvalidos.push('BAIRRO');
      }
      if (this.enderecoEntrega.numero === null || this.enderecoEntrega.numero === undefined) {
        camposInvalidos.push('Nº');
      }

      if (this.tipo === 1 && !this.criandoPedidoSemValidacao) {
        if (this.enderecoEntrega.cpfCnpj === null || this.enderecoEntrega.cpfCnpj === undefined) {
          camposInvalidos.push('CPF/CNPJ');
        }
        if (
          this.enderecoEntrega.tipo !== 1 &&
          this.premissas.inscricaoEstadualObg &&
          (this.enderecoEntrega.rgIe === null || this.enderecoEntrega.rgIe === undefined)
        ) {
          camposInvalidos.push('RG/Insc. E.');
        }
        if (this.enderecoEntrega.nome === null || this.enderecoEntrega.nome === undefined) {
          camposInvalidos.push('Nome');
        }
      }

      this.camposInvalidosEnderecoEntrega = camposInvalidos.join(' / ');
    } else {
      this.camposInvalidosEnderecoEntrega = '';
    }
  }

  async alterarValorTotal() {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(InserirValorModalComponent, {
      width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
      data: {
        valorSemDesconto: await this.atualizaValores(TipoCalculoPedido.SimularDesconto, 0),
        valorAnterior:
          this.valorTotalFixo !== null && this.valorTotalFixo !== undefined
            ? Number(this.valorTotalFixo)
            : Number(this.valorTotal),
        valorMinimo:
          this.da === 0
            ? await this.atualizaValores(
                TipoCalculoPedido.SimularDesconto,
                (Number(this.valorProdutos) * this.descontoMaximo) / 100
              )
            : Number(this.valorTotal)
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        let novoDesconto = await this.atualizaValores(TipoCalculoPedido.SimularValorFinal, Number(result));
        if (novoDesconto < 0) {
          swal({
            title: 'ATENÇÃO!!!',
            html: 'Não foi possível chegar no valor especificado!!!',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-warning',
            type: 'warning'
          }).catch(swal.noop);
        } else {
          this.alterou = true;
          this.valorDa = Number(novoDesconto.toFixed(2));
          this.usandoArredondamento = true;
          await this.atualizaDesconto(1, true);
          // novo
          this.valorTotalFixo = Number(result);

          if (this.usandoMultiFormasPagamento) {
            this.formasPagamento = await this.calcularFormasDePagamento(
              this.formasPagamento,
              this.valorParaFormasPagamento,
              this.valorTotalFixo
            );
          }
        }
      }
    });
  }

  async calcularFormasDePagamento(formas, valorParaFormas, valorTotal) {
    try {
      this.carregandoService.mostra('calcularFormasDePagamento');

      return await this.pedidoService.calcularFormasDePagamento(formas, valorParaFormas, valorTotal).toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('calcularFormasDePagamento');
    }
  }

  async atualizaMultiFormasPagamento() {
    await this.atualizarTaxaDeCondicao();
  }

  abrirModalMultiFormasPagamento() {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(MultiFormaPagamentoModalComponent, {
      width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
      data: {
        formasPagamentoMulti: this.formasPagamento,
        valorSubTotalPedido: this.valorTotal,
        valorPedido: this.valorTotal,
        editavel: !this.integrador,
        pCentroDistribuicao: this.premissas.pCentroDistribuicao,
        pMultiFornecedor: this.premissas.pMultiFornecedor,
        idCD: this.idFornecedor
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result && result.alterou) {
        this.formasPagamento = result.formasPagamento;
        this.alterou = true;
        await this.atualizaMultiFormasPagamento();
      }
    });
  }

  baixarTermo() {
    this.carregandoService.mostra('termosDeUso');

    this.pedidoService.baixarTermo().subscribe(
      (resp) => {
        this.utilitarioService.openBlobModal(resp);

        this.carregandoService.esconde('termosDeUso');
      },
      (erro) => {
        const reader = new FileReader();

        // This fires after the blob has been read/loaded.
        reader.addEventListener('loadend', (e) => {
          const text = e.srcElement['result'];
          this.carregandoService.esconde('termosDeUso');
          this.notificacaoService.erro(text);
        });

        // Start reading the blob as text.
        reader.readAsText(erro.error);
      }
    );

    return false;
  }

  confirmarPedido(anexar) {
    const mensagem = 'Deseja realmente CONFIRMAR o Pedido?';
    swal({
      title: 'ATENÇÃO!',
      text: mensagem,
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        if (anexar) {
          const largura = Number($('body').width());

          const dialogRef = this.dialog.open(AnexoModalComponent, {
            width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
            data: { idCupom: '' },
            panelClass: 'modal-card'
          });

          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              this.fechar(true, result);
            }
          });
        } else {
          this.fechar(true);
        }
      }
    });
  }

  selecionarSegurosObrigatorios() {
    const kwpPedido = this.potencia;

    this.segurosSelecionados = this.segurosSelecionados.filter(
      (p) => !this.segurosObrigatorios.some((x) => x.idSeguro === p.idSeguro)
    );

    this.segurosObrigatorios = this.seguros
      .filter(
        (p) =>
          kwpPedido <= p.obgAte &&
          p.obgAte != 0 &&
          !this.segurosManuais.some((x) => x.idSeguro === p.id) &&
          !this.segurosObrigatoriosRemovidos.some((x) => x.idSeguro === p.id)
      )
      .map((p) => ({ idSeguro: p.id, idCupom: this.idCupom, valor: 0, obrigatorioRemovido: false }));

    this.segurosSelecionados = [...this.segurosObrigatorios, ...this.segurosSelecionados];
  }

  selecionarSegurosManuais() {
    this.segurosManuais = this.seguros
      .filter((p) => this.valorTotal >= p.manualAPartirDe)
      .map((p) => ({
        idSeguro: p.id,
        idCupom: this.idCupom,
        obrigatorioRemovido: false,
        valor: this.segurosSelecionados.find((x) => x.idSeguro === p.id)
          ? this.segurosSelecionados.find((x) => x.idSeguro === p.id).valor
          : 0
      }));
  }

  calcularValorSeguro(percSeguro): number {
    if (this.premissas.regraCalculos === 0) {
      return (percSeguro / 100) * this.valorTotal;
    } else {
      return this.valorTotal / (1 - percSeguro / 100) - this.valorTotal;
    }
  }

  async selecionarSeguro(seguro: Seguro, $event?) {
    this.alterou = true;
    if (!this.permissoesPedidoFuncionario.podeEditarSeguro) {
      if (this.verificaSeSeguroObrigatorio(seguro) || (this.integrador && this.verificaSeSeguroManual(seguro))) {
        if ($event) {
          $event.target.checked = this.verificaSeSeguroObrigatorio(seguro);
        }

        return;
      }

      if (
        this.segurosSelecionados.map((p) => p.idSeguro).includes(seguro.id) &&
        !this.segurosObrigatorios.map((p) => p.idSeguro).includes(seguro.id)
      ) {
        this.segurosSelecionados = [...this.segurosSelecionados.filter((p) => p.idSeguro !== seguro.id)];

        await this.atualizaValores();
      } else {
        this.segurosSelecionados.push({
          idSeguro: seguro.id,
          idCupom: this.idCupom,
          valor: 0,
          obrigatorioRemovido: false
        });

        if ($event) {
          $event.target.checked = false;
        }

        await this.atualizaValores();
      }
    } else {
      if (this.segurosSelecionados.map((p) => p.idSeguro).includes(seguro.id)) {
        this.segurosSelecionados = [...this.segurosSelecionados.filter((p) => p.idSeguro !== seguro.id)];

        if (this.verificaSeSeguroObrigatorio(seguro)) {
          this.segurosObrigatoriosRemovidos.push({
            idSeguro: seguro.id,
            idCupom: this.idCupom,
            valor: 0,
            obrigatorioRemovido: true
          });
        }

        await this.atualizaValores();
      } else {
        this.segurosSelecionados.push({
          idSeguro: seguro.id,
          idCupom: this.idCupom,
          valor: 0,
          obrigatorioRemovido: false
        });

        if (this.verificaSeSeguroObrigatorio(seguro)) {
          this.segurosObrigatoriosRemovidos = [
            ...this.segurosObrigatoriosRemovidos.filter((p) => p.idSeguro !== seguro.id)
          ];
        }

        if ($event) {
          $event.target.checked = false;
        }

        await this.atualizaValores();
      }
    }
  }

  calcularTotalValorSeguro() {
    if (!this.segurosSelecionados.length) {
      return 0;
    }

    this.seguros.forEach((seguro) => {
      if (this.verificaSeSeguroManual(seguro)) {
        if ((!seguro.valor || seguro.valor === null) && this.segurosManuais.find((p) => p.idSeguro === seguro.id)) {
          seguro.valor = this.segurosManuais.find((p) => p.idSeguro === seguro.id).valor;
        }
      } else {
        seguro.valor = Number(this.calcularValorSeguro(seguro.percentual).toFixed(2));
      }
    });

    this.segurosSelecionados.forEach((seguro) => {
      const seguroFind = this.seguros.find((p) => p.id === seguro.idSeguro);

      seguro.valor = seguroFind ? seguroFind.valor : seguro.valor;
    });

    return this.segurosSelecionados.reduce((acc, curr) => {
      return acc + curr.valor;
    }, 0);
  }

  verificaSeSeguroObrigatorio(seguro: Seguro): boolean {
    return this.segurosObrigatorios.some((p) => p.idSeguro === seguro.id);
  }

  verificaSeSeguroManual(seguro: Seguro): boolean {
    return this.segurosManuais.some((p) => p.idSeguro === seguro.id);
  }

  verificaSeSeguroSelecionado(seguro: Seguro): boolean {
    return this.segurosSelecionados.some((p) => p.idSeguro === seguro.id);
  }

  abrirModalValorManual(seguro: Seguro) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(AlterarValorSeguroModalComponent, {
      width: largura > 350 ? '380px' : $('body').width().toString() + 'px',
      data: { idSeguro: seguro.id, valorSeguro: seguro.valor },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        this.seguros.find((p) => p.id === result.idSeguro).valor = result.valorSeguro;
        await this.atualizaValores();
      }
    });
  }

  async completarEnderecoEntrega(restaurar: boolean, marcarComoAlterado: boolean) {
    if (restaurar) {
      this.enderecoEntrega = new VendaEntrega();
      this.enderecoEntrega.tipoEndereco = TipoEnderecoEntrega.NaoInformado;
      this.enderecoEntrega.uf = this.estadoSelecionado;
      this.enderecoEntrega.ibge = this.cidadeSelcionado;

      if (this.cidades && this.cidades.length === 0) {
        await this.buscarCidadesPorEstado(false);
      }

      this.enderecoEntrega.cidade = this.cidades.find((s) => s.cod === this.enderecoEntrega.ibge.toString())
        ? this.cidades.find((s) => s.cod === this.enderecoEntrega.ibge.toString()).cidade
        : '';

      this.tipoEnderecoSelecionado = TipoEnderecoEntrega.NaoInformado;
      await this.completarEnderecoEntrega(false, true);
    }

    if (this.enderecoEntrega === undefined || this.enderecoEntrega === null) {
      this.tipoEnderecoSelecionado = TipoEnderecoEntrega.NaoInformado;
      return;
    }

    if (this.enderecoEntrega.tipoEndereco !== TipoEnderecoEntrega.NaoInformado) {
      return;
    }

    switch (this.premissasSistema.tipoEnderecoEntregaPadrao) {
      case 1:
        if (this.clienteIntegrador) {
          await this.copiaEnderecoIntegrador();
        }
        break;
      case 2:
        if (this.vendaDireta && this.clienteFaturamento) {
          await this.copiaEnderecoVendaDireta();
        }
        break;
      case 3:
        // if (this.clienteIntegrador && this.cliente) {
        //   if (this.enderecoEntrega.cidade === this.cliente.cidade && this.enderecoEntrega.uf === this.cliente.uf) {
        //     await this.copiaEnderecoIntegrador();
        //   }
        // }
        break;
      default:
        this.gerarEnderecoEntregaCompleto();
        break;
    }

    if (marcarComoAlterado) {
      this.alterou = true;
      this.freteManual = false;

      if (this.premissasSistema.limparCupomDescontoAoAlterarCidadeEntrega) {
        await this.excluirCupomDesconto();
      }
    }
  }

  async alterouTipoCif() {
    this.alterou = true;
    this.freteManual = false;

    // if (this.tipoCIF === 0 && this.premissasSistema.excluirCupomDescontoAoMudarLocalizacao) {
    //   await this.excluirCupomDesconto();
    // }

    if (this.premissasSistema.excluirCupomDescontoAoMudarTipoFreteCif) {
      await this.excluirCupomDesconto();
    }

    await this.alteraFrete();
    this.avaliarMensagemDescarga();
  }

  gerarEnderecoEntregaCompleto() {
    if (this.enderecoEntrega === null || this.enderecoEntrega === undefined) {
      this.enderecoEntregaCompleto = '';
      return;
    }

    const componentes: string[] = [];

    if (this.enderecoEntrega.rua) {
      componentes.push(this.enderecoEntrega.rua);
    }

    if (this.enderecoEntrega.numero) {
      componentes.push(this.enderecoEntrega.numero);
    }

    if (this.enderecoEntrega.bairro) {
      componentes.push(this.enderecoEntrega.bairro);
    }

    if (this.enderecoEntrega.cidade) {
      componentes.push(`${this.enderecoEntrega.cidade}/${this.enderecoEntrega.uf}`);
    }

    if (this.enderecoEntrega.cep) {
      componentes.push(`CEP ${this.enderecoEntrega.cep}`);
    }

    if (this.enderecoEntrega.complemento) {
      componentes.push(this.enderecoEntrega.complemento);
    }

    this.enderecoEntregaCompleto = componentes.join(', ');
  }

  async atualizaValorProduto(item: ItemPedido) {
    let descontar = false;
    let desconto = 0;

    if (item.produtoTela.familia === 2 || item.produtoTela.familia === 3) {
      desconto = await this.buscarDescontoProduto(item);
      descontar = true;
      item.itemDesc.preco = item.produtoTela.precoVenda;
    }

    item.pUnitario = descontar
      ? Number((item.produtoTela.precoVenda - (item.produtoTela.precoVenda * desconto) / 100).toFixed(2))
      : Number(item.produtoTela.precoVenda.toFixed(2));

    item.pUnitario = this.calcularPrecificacao(item.pUnitario);

    if (this.descontoIndividual) {
      item.vTotal = Number((item.pUnitario * item.qt).toFixed(2));
      item.valorDa = Number(((item.vTotal * item.percentual) / 100).toFixed(2));
      item.vTotal = item.vTotal - item.valorDa;

      this.validarDescontoIndividual(item, true);
    } else {
      item.vTotal = Number((item.pUnitario * item.qt).toFixed(2));
    }
  }

  async buscarPrecificacoesUF() {
    try {
      this.carregandoService.mostra('buscarPrecificacoesUF');
      this.precificacoesUF = await this.precificacaoUFService.consultar().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPrecificacoesUF');
    }
  }

  async buscarDescontoProduto(item: ItemPedido) {
    try {
      this.carregandoService.mostra('buscarDescontoProduto');

      if (item.itemDesc === null || item.itemDesc === undefined) {
        item.itemDesc = new ItemDesc();
      }

      item.itemDesc.descontos =
        item.itemDesc.descontos === null || item.itemDesc.descontos === undefined
          ? await this.produtoService.consultarDescontos(item.produtoTela.idProduto).toPromise()
          : item.itemDesc.descontos;

      if (item.itemDesc.descontos.some((p) => item.qt >= p.qtdIni && item.qt <= p.qtdFim)) {
        this.carregandoService.esconde('buscarDescontoProduto');
        return item.itemDesc.descontos.find((p) => item.qt >= p.qtdIni && item.qt <= p.qtdFim).desco;
      } else {
        this.carregandoService.esconde('buscarDescontoProduto');
        return 0;
      }
    } catch (erro) {
      this.carregandoService.esconde('buscarDescontoProduto');
      this.notificacaoService.erro(erro);
      return 0;
    }
  }

  descontoIndividualAplicadoParaTodos() {
    const distinctDescontos = Array.from(new Set(this.itens.map((p) => p.percentual)));
    return distinctDescontos.length === 1 && distinctDescontos[0] > 0 && distinctDescontos[0] <= this.descontoMaximo;
  }

  validarDescontoIndividual(item: ItemPedido, exibirMsg: boolean) {
    const valorTotalItens = this.itens.reduce((acc, curr) => acc + Number(curr.pUnitario) * Number(curr.qt), 0);
    const valorTotalItensComDesconto = this.itens.reduce((acc, curr) => acc + curr.vTotal, 0);

    if (this.descontoIndividualAplicadoParaTodos()) return;

    if (
      item.valorDa > 0 &&
      item.percentual > 0 &&
      (100 * (valorTotalItens - valorTotalItensComDesconto)) / valorTotalItens > this.descontoMaximo
    ) {
      const valorDaMaximo = Number(((valorTotalItens * this.descontoMaximo) / 100).toFixed(2));
      const valorDaAtual = Number((valorTotalItens - valorTotalItensComDesconto).toFixed(2));
      const diferencaDa = Number((valorDaAtual - valorDaMaximo).toFixed(2));

      if (diferencaDa === 0) return;

      const valorItemSemDesconto = Number((Number(item.qt) * Number(item.pUnitario)).toFixed(2));
      const valorItem =
        item.vTotal + diferencaDa > valorItemSemDesconto ? valorItemSemDesconto : item.vTotal + diferencaDa;
      const percentualItem = ((valorItemSemDesconto - valorItem) * 100) / valorItemSemDesconto;

      if (exibirMsg) {
        swal({
          title: 'ATENÇÃO!!',
          html: 'Desconto acima do permitido: <b>' + this.descontoMaximo.toLocaleString(),
          type: 'warning',
          confirmButtonClass: 'btn btn-warning',
          buttonsStyling: false,
          allowEnterKey: false
        }).then(async (result) => {
          item.percentual = percentualItem;
          item.valorDa = valorItemSemDesconto - valorItem;
          item.vTotal = valorItem;
          this.alterou = true;
          await this.atualizaValores();
        });
      } else {
        item.percentual = percentualItem;
        item.valorDa = valorItemSemDesconto - valorItem;
        item.vTotal = valorItem;
      }
    }
  }

  async atualizarDescontoPrecificacaoUF() {
    if (this.premissasSistema.usarPrecificacaoPorUF && this.origem !== 2) {
      this.descAcresPrecificacaoUF = this.precificacoesUF.some((p) => p.uf === this.enderecoEntrega.uf)
        ? this.precificacoesUF.find((p) => p.uf === this.enderecoEntrega.uf)
        : { percentual: 0, uf: '', tipoDa: 0 };

      for (const [idx, item] of this.itens.entries()) {
        await this.atualizaValorProduto(item);
      }

      const tempValor = this.valorProdutos;

      this.valorProdutos = Number(
        this.itens.reduce((acc, curr) => acc + Number(curr.pUnitario) * Number(curr.qt), 0).toFixed(2)
      );

      if (this.valorProdutos.toFixed(2) !== tempValor.toFixed(2)) {
        this.alterouValorProdutos = true;
      }

      await this.atualizaDesconto(
        this.valorTotalFixo !== null && this.valorTotalFixo !== undefined && this.valorTotalFixo > 0 ? 1 : 0,
        this.valorTotalFixo !== null && this.valorTotalFixo !== undefined && this.valorTotalFixo > 0
      );
    }
  }

  calcularPrecificacao(precoUnitario: number) {
    const precoBase = precoUnitario;

    if (this.premissasSistema.usarPrecificacaoPorUF) {
      precoUnitario = this.precificacaoUFService.calcularPrecificacaoUF(precoBase, this.descAcresPrecificacaoUF);
    }

    if (this.premissasSistema.habilitarPrecificacaoPorIntegrador && this.cliente && this.origem === 3) {
      precoUnitario = this.precificacaoUFService.calcularPrecificacaoIntegrador(
        precoUnitario,
        precoBase,
        this.cliente.tipoPrecificacao,
        this.cliente.valorPrecificacao
      );
    }

    return precoUnitario;
  }

  async buscarPremissasUsuario() {
    try {
      this.carregandoService.mostra('buscarPremissasUsuario');
      this.premissasUsuario = await this.premissasService.consultarPremissasUsuario().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasUsuario');
    }
  }

  resetarFormasPagamento() {
    if (this.usandoMultiFormasPagamento) {
      this.formasPagamento = [];
    } else {
      this.formasPagamento = [];
      // this.formasPagamento.push(new VendaFormaPag());
      // this.formasPagamento[0].tipo = TipoVendaFormaPag.Variavel;
    }

    this.alterou = true;
    this.atualizaValores();
  }

  montarImpostosTotal(): any[] {
    return Object.values<any>(
      this.impostos.reduce((accumulator, currentItem) => {
        const key = currentItem.imposto;
        if (accumulator[key]) {
          accumulator[key].valor += currentItem.valor;
        } else {
          accumulator[key] = {
            imposto: currentItem.imposto.toUpperCase(),
            valor: currentItem.valor,
            soma: currentItem.soma
          };
        }
        return accumulator;
      }, {})
    ); /*.filter(p => p.valor > 0)*/
  }

  async alterouTipoDesconto() {
    this.alterou = true;
    this.percentual = 0;
    await this.buscarDescontoMaximo();
    await this.atualizaDesconto(0);
  }

  async alterouFormaPagamento() {
    this.alterou = true;
    // this.verificaFormaPagamentoRepasse();
    await this.atualizarTaxaDeCondicao();
    await this.recalculaFreteManual();
  }

  verificaFormaPagamentoRepasse() {
    // verifica se buscou as formas de pagamento
    if (this.formasDePagamento != null && this.formasDePagamento != undefined && this.formasDePagamento.length > 0) {
      if (
        this.pedidoComFormaDePagamento() &&
        this.formasPagamento.some((p) => p.idFormaPag !== undefined && p.idFormaPag !== null)
      ) {
        const formas = this.formasPagamento.filter((p) => p.idFormaPag !== undefined && p.idFormaPag !== null);

        this.formaDePagamentoRepasse = this.formasDePagamento.some(
          (p) => formas.some((f) => f.idFormaPag === p.id) && p.repasse
        );

        if (!this.formaDePagamentoRepasse) {
          this.valorServico = 0;
        }
      }
    }
  }

  possuiRepasse() {
    return this.valorServico === null || this.valorServico === undefined || Number(this.valorServico) === 0
      ? null
      : true;
  }

  pedidoComFormaDePagamento() {
    return this.formasPagamento !== null && this.formasPagamento !== undefined && this.formasPagamento.length > 0;
  }

  pedidoComCondicaoDePagamento() {
    return (
      this.pedidoComFormaDePagamento() &&
      this.formasPagamento[0].idCondPag !== null &&
      this.formasPagamento[0].idCondPag !== undefined
    );
  }

  // Forma única sem condição tem taxa 0; true quando o cupom ainda carrega a taxa antiga.
  possuiTaxaSemCondicao() {
    return (
      !this.usandoMultiFormasPagamento &&
      !this.pedidoComCondicaoDePagamento() &&
      ((Number(this.taxaCondicao) || 0) !== 0 || (Number(this.valorTaxaCond) || 0) !== 0)
    );
  }

  validarVendaDireta() {
    return (
      this.vendaDireta !== null &&
      this.vendaDireta !== undefined &&
      (!this.vendaDireta || (this.vendaDireta && this.vendaDiretaComp && this.vendaDiretaComp.validar()))
    );
  }

  async alterouTipoFrete() {
    this.alterou = true;
    this.freteManual = false;

    await this.defineEnderecoEntregaFob();

    await this.alteraFrete();
    this.avaliarMensagemDescarga();
  }

  async defineEnderecoEntregaFob() {
    if (this.tipoFrete === 1 && !this.premissasSistema.mostrarEnderecoEntregaFob) {
      this.enderecoEntrega.tipoEndereco = this.vendaDireta
        ? TipoEnderecoEntrega.VendaDireta
        : TipoEnderecoEntrega.Integrador;
      await this.alterouTipoDeEnderecoEntrega();

      // this.nomeResponsavel = this.enderecoEntrega.nome;
      // this.telefoneResponsavel = this.enderecoEntrega.celular;
    }
  }

  async alterouPraQuemVaiFaturar() {
    this.alterou = true;

    if (!this.vendaDireta) {
      this.clienteFaturamento = undefined;
      // this.editandoVendaDireta = false;

      if (this.cliente !== undefined && this.enderecoEntrega.tipoEndereco === TipoEnderecoEntrega.VendaDireta) {
        await this.completarEnderecoEntrega(true, true);
      }

      if (this.origem === 3 && this.premissasSistema.habilitarApiImposto) {
        await this.atualizaValores();
      }

      await this.defineEnderecoEntregaFob();
    } else {
      this.definirDadosVendaDireta();
      // this.editandoVendaDireta = true;
    }

    this.buscarTiposDeEnderecoEntrega();
  }

  async retornoVendaDireta(cliente: Cliente) {
    // this.editandoVendaDireta = false;

    if (cliente) {
      this.clienteFaturamento = cliente;

      if (!this.validarVendaDireta()) {
        return;
      }

      if (!this.clienteFaturamento.salvar) {
        this.alterou = true;
      }

      this.clienteFaturamento.salvar = true;

      if (this.enderecoEntrega.tipoEndereco !== TipoEnderecoEntrega.VendaDireta) {
        await this.completarEnderecoEntrega(false, true);
      } else {
        await this.copiaEnderecoVendaDireta();
      }

      await this.defineEnderecoEntregaFob();

      if (this.origem === 3 && this.premissasSistema.habilitarApiImposto) {
        await this.atualizaValores();
      }
    } else {
      if (
        this.clienteFaturamento === null ||
        this.clienteFaturamento === undefined ||
        this.clienteFaturamento.cep === null ||
        this.clienteFaturamento.cep === undefined
      ) {
        this.vendaDireta = false;
        this.clienteFaturamento = undefined;
      }
    }

    this.buscarTiposDeEnderecoEntrega();
  }

  async retornoEnderecoEntrega(result: VendaEntrega) {
    if (result) {
      this.enderecoEntrega = result;

      this.ibgeEntrega = this.enderecoEntrega.ibge
        ? await this.ibgeService.buscarCidadePorCodIGBE(this.enderecoEntrega.ibge.toString()).toPromise()
        : undefined;

      this.alterou = true;
      this.mostraMsgEnderecoAdicional = true;

      this.gerarEnderecoEntregaCompleto();
      await this.atualizarDescontoPrecificacaoUF();
      await this.buscarFrete();

      if (this.premissasSistema.limparCupomDescontoAoAlterarCidadeEntrega) {
        await this.excluirCupomDesconto();
      }
    }

    this.editandoEnderecoEntrega = false;
  }

  definirDadosVendaDireta() {
    // this.dadosVendaDireta.clienteFaturamento = this.clienteFaturamento === null || this.clienteFaturamento === undefined ? new Cliente() : Object.assign({}, this.clienteFaturamento);

    if (this.clienteFaturamento === null || this.clienteFaturamento === undefined) {
      this.clienteFaturamento = new Cliente();
    }

    this.buscouClienteFaturamento = true;
  }

  buscarTiposDeEnderecoEntrega() {
    this.tiposDeEnderecoEntrega = [];

    if (this.cliente) {
      this.tiposDeEnderecoEntrega.push({ id: TipoEnderecoEntrega.Integrador, nome: 'Integrador' });
    }

    if (this.vendaDireta && this.clienteFaturamento !== null && this.clienteFaturamento !== undefined) {
      this.tiposDeEnderecoEntrega.push({ id: TipoEnderecoEntrega.VendaDireta, nome: 'Cliente Final' });
    }

    if (this.premissas.cadastrarEnderecoEntrega) {
      this.tiposDeEnderecoEntrega.push({ id: TipoEnderecoEntrega.Personalizado, nome: 'Personalizado' });
    }
  }

  async alterouTipoDeEnderecoEntrega() {
    this.alterou = true;

    switch (this.enderecoEntrega.tipoEndereco) {
      case TipoEnderecoEntrega.Integrador:
        await this.copiaEnderecoIntegrador();
        break;

      case TipoEnderecoEntrega.VendaDireta:
        await this.copiaEnderecoVendaDireta();
        break;

      case TipoEnderecoEntrega.Personalizado:
        this.editandoEnderecoEntrega = true;
        this.enderecoEntrega = new VendaEntrega();
        this.enderecoEntrega.tipoEndereco = TipoEnderecoEntrega.Personalizado;
        // this.adicionarEnderecoEntrega();
        break;

      default:
        break;
    }
  }

  buscaValorMarkup() {
    const objeto: {
      itens: ItemPedido[];
      valorTotal: number;
      valorFinal: number;
      subTotal: number;
      aliqImpRef: number;
      da: number;
      valorDa: number;
      valorFrete: number;
      taxaDa: number;
      valorRepasse: number;
      idCupom: string;
      idFornecedor: number;
      mostraValoresServico: boolean;
    } = {
      itens: this.itens,
      valorTotal: this.valorProdutos,
      valorFinal:
        this.valorTotalFixo === null || this.valorTotalFixo === undefined ? this.valorTotal : this.valorTotalFixo,
      subTotal: 0,
      aliqImpRef: this.aliqImpRef,
      da: this.da,
      valorDa: this.valorDa,
      valorFrete: this.valorFrete,
      taxaDa: this.valorTaxaCond,
      valorRepasse: this.valorLiquido,
      idCupom: this.idCupom,
      idFornecedor: this.idFornecedor,
      mostraValoresServico: true
    };

    this.carregandoService.mostra('calculoIndicador');

    this.indicadorService.calculoIndicador(objeto).subscribe(
      async (data) => {
        if (this.mostrarValoresServico !== data.mostraValoresServico) {
          this.mostrarValoresServico = data.mostraValoresServico;

          if (this.alterou && !this.mostrarValoresServico) {
            this.valorServico = 0;
            this.valorLiquido = 0;
            await this.atualizaValores();
          }
        }

        this.carregandoService.esconde('calculoIndicador');
      },
      (erro) => {
        this.carregandoService.esconde('calculoIndicador');
      }
    );
  }

  ngOnDestroy(): void {
    if (this.observer !== undefined && this.observer !== null) {
      this.observer.disconnect();
    }
  }

  // testeValidar() {
  //   let a = this.validarPreenchimentoQuestionario();
  //   a = this.tipoCIF != null;
  //   a = this.localizacao != null;
  //   a = this.validarCD();
  //   a = this.vendaDireta === null || this.vendaDireta === undefined || this.validarVendaDireta();
  //   a = this.validarTipoFrete(false);

  //   a = !this.informarNome || (this.informarNome && this.nome);
  //   a =
  //     !this.selecionarIntegrador ||
  //     (this.selecionarIntegrador &&
  //       this.cliente &&
  //       (!this.premissas.usarTbFrete ||
  //         (this.premissas.usarTbFrete && this.tipoFrete !== null && this.tipoFrete !== undefined)));
  //   a =
  //     this.vendaDireta && this.tipoFrete === 0
  //       ? this.enderecoEntrega !== null &&
  //         this.enderecoEntrega !== undefined &&
  //         this.enderecoEntrega.tipoEndereco !== 0 &&
  //         this.enderecoEntrega.cep !== null &&
  //         this.enderecoEntrega.cep !== undefined &&
  //         (this.enderecoEntrega.antigo ||
  //           (this.enderecoEntrega.tipo !== null &&
  //             this.enderecoEntrega.tipo !== undefined &&
  //             this.enderecoEntrega.cpfCnpj !== null &&
  //             this.enderecoEntrega.cpfCnpj !== undefined &&
  //             this.enderecoEntrega.cpfCnpj !== '' &&
  //             (this.enderecoEntrega.tipo === 1 ||
  //               !this.premissas.inscricaoEstadualObg ||
  //               (this.enderecoEntrega.rgIe !== null &&
  //                 this.enderecoEntrega.rgIe !== undefined &&
  //                 this.enderecoEntrega.rgIe !== '')) &&
  //             this.enderecoEntrega.nome !== null &&
  //             this.enderecoEntrega.nome !== undefined &&
  //             this.enderecoEntrega.nome !== ''))
  //       : true;
  // }
}
